import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-editor-container app-page app-page--fill" }
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = { class: "form-list-wrapper" }
const _hoisted_4 = {
  class: "right-panel",
  "element-loading-text": "加载中..."
}
const _hoisted_5 = {
  key: 0,
  class: "edit-area"
}
const _hoisted_6 = { class: "edit-mode-control" }
const _hoisted_7 = {
  key: 0,
  class: "limited-field"
}
const _hoisted_8 = {
  key: 1,
  class: "form-text"
}
const _hoisted_9 = { class: "limited-field" }
const _hoisted_10 = {
  key: 0,
  class: "limited-field"
}
const _hoisted_11 = {
  key: 1,
  class: "form-text"
}
const _hoisted_12 = {
  key: 0,
  class: "member-select-row"
}
const _hoisted_13 = { class: "form-text" }
const _hoisted_14 = {
  key: 1,
  class: "form-text"
}
const _hoisted_15 = { class: "team-tags-inline" }
const _hoisted_16 = {
  key: 0,
  class: "team-display-section"
}
const _hoisted_17 = { class: "team-tags-inline" }
const _hoisted_18 = {
  key: 1,
  class: "team-display-section"
}
const _hoisted_19 = { class: "team-tags-inline" }
const _hoisted_20 = { class: "building-count-row" }
const _hoisted_21 = {
  key: 2,
  class: "buildings-container"
}
const _hoisted_22 = { class: "buildings-list" }
const _hoisted_23 = {
  key: 0,
  class: "floor-setting"
}
const _hoisted_24 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_25 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_26 = { class: "floor-documents-section" }
const _hoisted_27 = {
  key: 0,
  class: "floor-documents-container"
}
const _hoisted_28 = { class: "floor-list" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "floor-upload-panel"
}
const _hoisted_31 = { class: "floor-upload-header" }
const _hoisted_32 = {
  key: 0,
  class: "upload-progress-container"
}
const _hoisted_33 = { class: "progress-text" }
const _hoisted_34 = {
  key: 0,
  class: "el-upload__text"
}
const _hoisted_35 = {
  key: 1,
  class: "el-upload__tip"
}
const _hoisted_36 = {
  key: 2,
  class: "uploaded-files-info"
}
const _hoisted_37 = { class: "files-header" }
const _hoisted_38 = { class: "files-list" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "file-thumbnail-wrapper" }
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 1,
  class: "pdf-thumbnail"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "file-name" }
const _hoisted_45 = { style: {"margin-top":"10px"} }
const _hoisted_46 = {
  key: 1,
  class: "floor-documents-empty"
}
const _hoisted_47 = {
  key: 1,
  class: "action-buttons"
}
const _hoisted_48 = { class: "action-buttons-row" }
const _hoisted_49 = {
  key: 2,
  class: "selected-projects-tags"
}
const _hoisted_50 = { class: "tags-container" }
const _hoisted_51 = ["draggable", "onDragstart", "onDrop"]
const _hoisted_52 = {
  key: 3,
  class: "action-buttons-row action-buttons-right"
}
const _hoisted_53 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_54 = { class: "dialog-footer" }
const _hoisted_55 = {
  key: 0,
  class: "package-detail-content"
}
const _hoisted_56 = { class: "package-info" }
const _hoisted_57 = {
  key: 0,
  class: "package-description"
}
const _hoisted_58 = { class: "package-projects" }
const _hoisted_59 = { class: "dialog-footer" }
const _hoisted_60 = { class: "project-file-toolbar" }
const _hoisted_61 = { class: "dialog-footer" }
const _hoisted_62 = { class: "project-file-upload-dialog-title" }
const _hoisted_63 = { class: "project-file-upload-title-icon" }
const _hoisted_64 = { class: "project-file-upload-content" }
const _hoisted_65 = { class: "project-file-upload-zone-icon" }
const _hoisted_66 = {
  key: 0,
  class: "project-upload-file-list"
}
const _hoisted_67 = { class: "project-upload-file-list-header" }
const _hoisted_68 = { class: "project-upload-file-list-actions" }
const _hoisted_69 = { class: "project-upload-file-icon" }
const _hoisted_70 = ["title"]
const _hoisted_71 = { class: "dialog-footer" }
const _hoisted_72 = { class: "image-preview-container" }
const _hoisted_73 = ["src"]
const _hoisted_74 = ["src"]
const _hoisted_75 = {
  key: 2,
  class: "preview-loading"
}
const _hoisted_76 = { class: "dialog-footer" }
const _hoisted_77 = { class: "team-dialog-content" }
const _hoisted_78 = { class: "team-left-panel" }
const _hoisted_79 = { class: "team-panel-header" }
const _hoisted_80 = { class: "team-search-box" }
const _hoisted_81 = { class: "team-tree-wrapper" }
const _hoisted_82 = { class: "tree-node" }
const _hoisted_83 = { class: "node-label" }
const _hoisted_84 = { class: "team-tree-options" }
const _hoisted_85 = { class: "team-right-panel" }
const _hoisted_86 = { class: "team-panel-header" }
const _hoisted_87 = { class: "team-panel-title" }
const _hoisted_88 = {
  key: 0,
  class: "team-user-content"
}
const _hoisted_89 = { class: "team-filter-bar" }
const _hoisted_90 = { class: "team-table-wrapper" }
const _hoisted_91 = {
  key: 1,
  class: "team-empty-state"
}
const _hoisted_92 = {
  key: 2,
  class: "team-selected-preview"
}
const _hoisted_93 = { class: "preview-label" }
const _hoisted_94 = { class: "dept-dialog-content" }
const _hoisted_95 = { class: "dept-search-box" }
const _hoisted_96 = { class: "dept-tree-wrapper" }
const _hoisted_97 = { class: "tree-node" }
const _hoisted_98 = { class: "node-label" }

import { ref, computed, watch, nextTick, onMounted, onUnmounted } from 'vue';
import { Plus, Edit, Close, Upload, UploadFilled, Refresh, Minus, Document, View, Download, Delete } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox, UploadProps, UploadUserFile, genFileId } from 'element-plus';
import DynamicTable from '@/components/DynamicTable.vue';
import { ParameterSettings, PermissionManagement } from '@/network/index';
import type { ElTree } from 'element-plus';
import { Search, OfficeBuilding } from '@element-plus/icons-vue';
import { useButtonPermission } from '@/utils/buttonPermission';

interface FloorDocument {
  floorNumber: number;
  files: UploadUserFile[];
}

interface Building {
  id: string;
  code: string;
  name: string;
  floors: number; // 地上层数
  basementFloors: number; // 地下层数（0 表示无地下层）
  selected: boolean;
  floorDocuments: FloorDocument[];
  editing?: boolean;
}

interface FormData {
  id?: number;
  code: string;
  name: string;
  projectManagerCode?: string;
  projectManager: string;
  responsibleDepartment: string;
  status?: string;
  startTime: string | null;
  remark: string;
  buildingCount: number;
  buildings: Building[];
  projectAssistant: Record<string, string>;
  executionTeam: Record<string, string>;
}
// 添加用于存储缩略图URL的Map
const minPanelWidth = 200;

interface ProjectFileItem {
  项目编码?: string;
  相对路径?: string;
  文件名?: string;
  文件类型?: string;
  哈希值?: string;
  大小?: string | number;
  上传时间?: string;
  上传人?: string;
  Id?: string | number;
}

interface DepartmentNode {
  value: string;
  Pid: string;
  label: string;
  order: number;
  disabled: boolean;
  children: DepartmentNode[] | null;
}

interface TeamUserInfo {
  uID?: string;
  code?: string;
  uLoginName?: string;
  uRealName?: string;
  DepartmentName?: string;
  DepartmentId?: string;
}

type MemberSelectTarget = 'manager' | 'assistant' | 'execution';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { can, canAny } = useButtonPermission('/ParameterSettings/BusinessScope/index.vue');

let pdfjsLibPromise: Promise<any> | null = null;

const getPdfjsLib = async () => {
  if (!pdfjsLibPromise) {
    pdfjsLibPromise = import('pdfjs-dist/legacy/build/pdf').then(module => {
      module.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
      return module;
    });
  }
  return pdfjsLibPromise;
};

const thumbnailCache = new Map<string, string>(); // key: serverCode, value: thumbnail URL

// 左侧面板拖拽调整宽度相关
const mainContentRef = ref<HTMLElement | null>(null);
const leftPanelRef = ref<HTMLElement | null>(null);
const leftPanelWidth = ref<number>(0); // 初始为0，onMounted时设置为容器一半
const isResizing = ref<boolean>(false);
const startResize = (e: MouseEvent) => {
  isResizing.value = true;
  document.addEventListener('mousemove', handleResizePanel);
  document.addEventListener('mouseup', stopResize);
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
};

const handleResizePanel = (e: MouseEvent) => {
  if (!isResizing.value || !mainContentRef.value) return;
  const containerRect = mainContentRef.value.getBoundingClientRect();
  const maxWidth = containerRect.width / 2;
  let newWidth = e.clientX - containerRect.left;
  newWidth = Math.max(minPanelWidth, Math.min(maxWidth, newWidth));
  leftPanelWidth.value = newWidth;
};

const stopResize = () => {
  isResizing.value = false;
  document.removeEventListener('mousemove', handleResizePanel);
  document.removeEventListener('mouseup', stopResize);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
};

onUnmounted(() => {
  document.removeEventListener('mousemove', handleResizePanel);
  document.removeEventListener('mouseup', stopResize);
});

const activeFormIndex = ref<number>(-1);
// formList 存储接口返回的原始数据（用于左侧列表展示）
const formList = ref<any[]>([]);
const currentForm = ref<FormData | null>(null);
// 保存数据loading状态
const saveLoading = ref<boolean>(false);
const dynamicTableRef = ref<InstanceType<typeof DynamicTable> | null>(null);
const selectedBuildingIndex = ref<number | null>(null); // 当前选中的楼栋索引
const selectedFloorIndex = ref<number | null>(null); // 当前选中的楼层索引

// 加载状态
const loading = ref<boolean>(false); // 右侧详情区域加载状态
const listLoading = ref<boolean>(false); // 左侧列表加载状态
const quickSyncLoading = ref<boolean>(false); // 快速同步加载状态
const floorUploading = ref<boolean>(false); // 楼层图纸上传中状态
const floorUploadProgress = ref<number>(0); // 楼层图纸上传进度

// 筛选参数
const filterParams = ref<any[]>([]);
const quickKeyword = ref('');

// 分页相关状态
const formPagination = ref({
  show: true,
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100],
  layout: 'total, sizes, prev, pager, next, jumper',
  small: true
});

// model数据，用于表格表头展示
const tableModel = ref<Record<string, string> | undefined>(undefined);

// 编辑模式控制
const isEditMode = ref<boolean>(false);
// 当前选中数据是否允许编辑（由接口 editable 字段控制）
const currentFormEditable = ref<boolean>(false);
const canEnterEditMode = computed(() => !!currentForm.value && currentFormEditable.value);

const toEditableFlag = (value: unknown, fallback = false): boolean => {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
  }
  return fallback;
};

// 表单引用
const formRef = ref<any>(null);

// 表单验证规则
const formRules = {
  buildingCount: [
    { required: true, message: '请输入建筑个数', trigger: 'change' }
  ]
};

// 辅助函数：创建默认表单数据
const createEmptyForm = (): FormData => ({
  code: '',
  name: '',
  projectManagerCode: '',
  projectManager: '',
  responsibleDepartment: '',
  status: '',
  startTime: null,
  remark: '',
  buildingCount: 0,
  buildings: [],
  projectAssistant: {},
  executionTeam: {}
});


// 弹窗相关的变量
const dialogVisible = ref(false);
const activeTab = ref('package'); // 当前激活的Tab页：'package' 或 'project'

// 检测项目相关
const projectListData = ref<any[]>([]);
const projectTableModel = ref<Record<string, string> | undefined>(undefined);
const projectListLoading = ref(false);
const projectFilterParams = ref<any[]>([]);
const selectedProjectIds = ref<any[]>([]);
// 临时选择的项目ID（弹框内使用，点击确定后才同步到selectedProjectIds）
const tempSelectedProjectIds = ref<any[]>([]);
// 保存已选项目的完整数据（用于查看模式显示）
const selectedProjectsFullData = ref<any[]>([]);
const draggedProjectIndex = ref<number | null>(null);

const getProjectItemId = (item: any) => item?.Id ?? item?.id;
const getProjectIdKey = (id: any) => String(id);

// 检测项目包相关
const packageListData = ref<any[]>([]);
const packageTableModel = ref<Record<string, string> | undefined>(undefined);
const packageListLoading = ref(false);
const packageFilterParams = ref<any[]>([]);
const selectedPackageIds = ref<any[]>([]);
// 临时选择的项目包ID
const tempSelectedPackageIds = ref<any[]>([]);
// 保存已选项目包的完整数据
const selectedPackagesFullData = ref<any[]>([]);

// 检测项目包详情弹框相关
const packageDetailVisible = ref(false);
const currentPackageDetail = ref<any>(null);
const packageDetailProjects = ref<any[]>([]);
const packageDetailProjectsModel = ref<Record<string, string> | undefined>(undefined);
const packageDetailLoading = ref(false);

const projectFileDialogVisible = ref(false);
const projectFiles = ref<ProjectFileItem[]>([]);
const projectFilesLoading = ref(false);
const projectFilesLoadedProjectId = ref<string>('');
const downloadingFileId = ref<string>('');
const deletingFileId = ref<string>('');
const clearingProjectFiles = ref(false);
const projectFileUploadDialogVisible = ref(false);
const projectUploadFileList = ref<UploadUserFile[]>([]);
const projectFilesUploading = ref(false);
const projectFileCount = computed(() => projectFiles.value.length);

const getCurrentOperatingProjectId = (): string => {
  const formId = currentForm.value?.id;
  if (formId !== undefined && formId !== null && formId !== 0) return String(formId);
  if (activeFormIndex.value < 0 || activeFormIndex.value >= formList.value.length) return '';
  const item = formList.value[activeFormIndex.value];
  const itemId = item?.Id ?? item?.id;
  return itemId !== undefined && itemId !== null ? String(itemId) : '';
};

const resetProjectFiles = () => {
  projectFiles.value = [];
  projectFilesLoadedProjectId.value = '';
  downloadingFileId.value = '';
  deletingFileId.value = '';
  clearingProjectFiles.value = false;
  projectFilesLoading.value = false;
};

const loadProjectFiles = async (projectId = getCurrentOperatingProjectId(), showError = projectFileDialogVisible.value) => {
  if (!projectId) {
    resetProjectFiles();
    return;
  }

  try {
    projectFilesLoading.value = true;
    const res: any = await ParameterSettings.operatingProjectFileStructure({ 项目id: projectId });
    const files = res?.status === 200 && res?.success && Array.isArray(res.response)
      ? res.response
      : [];

    if (getCurrentOperatingProjectId() === projectId) {
      projectFiles.value = files;
      projectFilesLoadedProjectId.value = projectId;
    }
  } catch (error) {
    console.error('加载当前项目文件失败:', error);
    if (getCurrentOperatingProjectId() === projectId) {
      projectFiles.value = [];
      projectFilesLoadedProjectId.value = projectId;
    }
    if (showError) {
      ElMessage.error('当前项目文件加载失败');
    }
  } finally {
    if (getCurrentOperatingProjectId() === projectId) {
      projectFilesLoading.value = false;
    }
  }
};

const openProjectFileDialog = async () => {
  const projectId = getCurrentOperatingProjectId();
  if (!projectId) {
    ElMessage.warning('请先选择一个经营项目');
    return;
  }

  projectFileDialogVisible.value = true;
  await loadProjectFiles(projectId, true);
};

const openProjectFileUploadDialog = () => {
  if (!getCurrentOperatingProjectId()) {
    ElMessage.warning('请先选择一个经营项目');
    return;
  }

  projectUploadFileList.value = [];
  projectFileUploadDialogVisible.value = true;
};

const resetProjectFileUpload = () => {
  projectUploadFileList.value = [];
  projectFilesUploading.value = false;
};

const removeProjectUploadFile = (file: UploadUserFile) => {
  projectUploadFileList.value = projectUploadFileList.value.filter(item => item.uid !== file.uid);
};

const clearProjectUploadFiles = () => {
  projectUploadFileList.value = [];
};

const uploadProjectFiles = async () => {
  const projectId = getCurrentOperatingProjectId();
  const files = projectUploadFileList.value.filter(file => file.raw instanceof File);
  if (!projectId) {
    ElMessage.warning('请先选择一个经营项目');
    return;
  }
  if (!files.length) {
    ElMessage.warning('请选择要上传的文件');
    return;
  }

  try {
    projectFilesUploading.value = true;
    const form = new FormData();
    files.forEach(file => form.append('文件列表', file.raw as File, file.name));
    await ParameterSettings.operatingProjectFileUpload({ 项目id: projectId }, form);
    ElMessage.success(`成功上传 ${files.length} 个文件`);
    projectFileUploadDialogVisible.value = false;
    await loadProjectFiles(projectId, true);
  } catch (error) {
    console.error('上传当前项目文件失败:', error);
    ElMessage.error('文件上传失败');
  } finally {
    projectFilesUploading.value = false;
  }
};

const formatFileSize = (value: string | number | undefined): string => {
  const size = Number(value);
  if (!Number.isFinite(size) || size < 0) return '-';
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  if (size < 1024 * 1024 * 1024) return `${(size / 1024 / 1024).toFixed(1)} MB`;
  return `${(size / 1024 / 1024 / 1024).toFixed(1)} GB`;
};

const downloadBlobFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || '项目文件';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const downloadProjectFile = async (row: ProjectFileItem) => {
  const projectId = getCurrentOperatingProjectId();
  const fileId = row.Id !== undefined && row.Id !== null ? String(row.Id) : '';
  if (!projectId || !fileId) {
    ElMessage.warning('缺少项目id或文件id，无法下载');
    return;
  }

  try {
    downloadingFileId.value = fileId;
    const res: any = await ParameterSettings.operatingProjectFileDownload({
      项目id: projectId,
      文件id: fileId
    });
    const blob = getDownloadBlob(res);
    if (!blob) {
      ElMessage.error('下载失败，未获取到文件内容');
      return;
    }
    downloadBlobFile(blob, row.文件名 || row.相对路径 || `项目文件_${fileId}`);
    ElMessage.success('下载成功');
  } catch (error) {
    console.error('下载当前项目文件失败:', error);
    ElMessage.error('下载失败');
  } finally {
    downloadingFileId.value = '';
  }
};

const deleteProjectFile = async (row: ProjectFileItem) => {
  const projectId = getCurrentOperatingProjectId();
  const fileId = row.Id !== undefined && row.Id !== null ? String(row.Id) : '';
  if (!projectId || !fileId) {
    ElMessage.warning('缺少项目id或文件id，无法删除');
    return;
  }

  try {
    await ElMessageBox.confirm(`确定要删除文件“${row.文件名 || row.相对路径 || ''}”吗？`, '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    });
    deletingFileId.value = fileId;
    await ParameterSettings.operatingProjectFileDelete({ 项目id: projectId, 文件id: fileId });
    ElMessage.success('删除成功');
    await loadProjectFiles(projectId, true);
  } catch (error) {
    if (error !== 'cancel' && error !== 'close') {
      console.error('删除当前项目文件失败:', error);
      ElMessage.error('删除失败');
    }
  } finally {
    deletingFileId.value = '';
  }
};

const clearProjectFiles = async () => {
  const projectId = getCurrentOperatingProjectId();
  if (!projectId) {
    ElMessage.warning('请先选择一个经营项目');
    return;
  }

  try {
    await ElMessageBox.confirm('确认要完全清除文件夹吗？', '危险操作', {
      confirmButtonText: '确认清空',
      cancelButtonText: '取消',
      type: 'error'
    });
    clearingProjectFiles.value = true;
    await ParameterSettings.operatingProjectFileClear({ 项目id: projectId });
    ElMessage.success('项目文件夹已清空');
    await loadProjectFiles(projectId, true);
  } catch (error) {
    if (error !== 'cancel' && error !== 'close') {
      console.error('清空项目文件夹失败:', error);
      ElMessage.error('清空项目文件夹失败');
    }
  } finally {
    clearingProjectFiles.value = false;
  }
};

// ========== 执行团队选择弹框相关 ==========
const teamDialogVisible = ref(false);
const memberSelectTarget = ref<MemberSelectTarget>('execution');
const teamTreeRef = ref<InstanceType<typeof ElTree>>();
const teamDepartmentTree = ref<DepartmentNode[]>([]);
const teamTreeLoading = ref(false);
const teamUserList = ref<TeamUserInfo[]>([]);
const teamUserLoading = ref(false);
const teamCurrentDepartment = ref<DepartmentNode | null>(null);
const teamFilterText = ref('');
const teamUserSearchText = ref('');
const teamShowSubUsers = ref(false);
// 弹框内临时选中的成员 {code: uRealName}
const tempExecutionTeam = ref<Record<string, string>>({});

// ========== 主责部门选择弹框相关 ==========
const deptDialogVisible = ref(false);
const deptTreeRef = ref<InstanceType<typeof ElTree>>();
const deptTreeData = ref<DepartmentNode[]>([]);
const deptTreeLoading = ref(false);
const deptFilterText = ref('');
const deptSelectedNode = ref<DepartmentNode | null>(null);
const deptTreeProps = {
  children: 'children',
  label: 'label',
  disabled: 'disabled'
};

const memberDialogTitle = computed(() => {
  if (memberSelectTarget.value === 'manager') return '选择项目负责人';
  if (memberSelectTarget.value === 'assistant') return '选择项目助理';
  return '选择执行团队成员';
});

const getTeamUserCode = (user: TeamUserInfo): string => {
  return String(user.code || user.uID || user.uLoginName || '').trim();
};

const getTeamUserName = (user: TeamUserInfo): string => {
  return String(user.uRealName || user.uLoginName || getTeamUserCode(user)).trim();
};

const teamTreeProps = {
  children: 'children',
  label: 'label',
  disabled: 'disabled'
};

// 打开人员选择弹框
const openMemberDialog = async (target: MemberSelectTarget) => {
  memberSelectTarget.value = target;
  if (target === 'manager') {
    const managerName = currentForm.value?.projectManager;
    const managerCode = currentForm.value?.projectManagerCode;
    tempExecutionTeam.value = managerName
      ? { [managerCode || managerName]: managerName }
      : {};
  } else if (target === 'assistant') {
    tempExecutionTeam.value = currentForm.value
      ? { ...currentForm.value.projectAssistant }
      : {};
  } else {
    tempExecutionTeam.value = currentForm.value
      ? { ...currentForm.value.executionTeam }
      : {};
  }
  teamDialogVisible.value = true;
  teamCurrentDepartment.value = null;
  teamUserList.value = [];
  teamFilterText.value = '';
  teamUserSearchText.value = '';
  if (teamDepartmentTree.value.length === 0) {
    await loadTeamDepartmentTree();
  }
};

// 加载部门树
const loadTeamDepartmentTree = async () => {
  try {
    teamTreeLoading.value = true;
    const res: Record<string, unknown> = await PermissionManagement.getDepartmentTree({ pid: '0' });
    const resAny = res as Record<string, unknown>;
    if (resAny && (resAny as Record<string, unknown>).status === 200 && (resAny as Record<string, unknown>).success) {
      const response = (resAny as Record<string, unknown>).response as Record<string, unknown>;
      if (response?.children && Array.isArray(response.children)) {
        teamDepartmentTree.value = response.children as DepartmentNode[];
      } else {
        teamDepartmentTree.value = response ? [response as unknown as DepartmentNode] : [];
      }
    } else {
      teamDepartmentTree.value = [];
    }
  } catch (error) {
    console.error('加载部门树失败:', error);
    teamDepartmentTree.value = [];
  } finally {
    teamTreeLoading.value = false;
  }
};

// 部门树节点点击
const handleTeamNodeClick = (data: DepartmentNode) => {
  teamCurrentDepartment.value = data;
  teamUserSearchText.value = '';
  loadTeamUserList();
};

// 部门树搜索
const handleTeamTreeFilter = () => {
  teamTreeRef.value?.filter(teamFilterText.value);
};

const filterTeamNode = (value: string, data: DepartmentNode) => {
  if (!value) return true;
  return data.label.includes(value);
};

// 显示下级人员切换
const handleTeamShowSubChange = () => {
  if (teamCurrentDepartment.value) {
    loadTeamUserList();
  }
};

// 人员搜索
const handleTeamUserSearch = () => {
  loadTeamUserList();
};

// 加载人员列表
const loadTeamUserList = async () => {
  if (!teamCurrentDepartment.value) return;
  try {
    teamUserLoading.value = true;
    const res: Record<string, unknown> = await PermissionManagement.getDepartmentUser({
      nameKey: teamUserSearchText.value || undefined,
      departmentId: teamCurrentDepartment.value.value,
      includesSubordinates: teamShowSubUsers.value,
    });
    const resAny = res as Record<string, unknown>;
    if (resAny && (resAny as Record<string, unknown>).status === 200 && (resAny as Record<string, unknown>).success) {
      const response = (resAny as Record<string, unknown>).response as Record<string, unknown>;
      teamUserList.value = Array.isArray(response?.data) ? (response.data as TeamUserInfo[]) : [];
    } else {
      teamUserList.value = [];
    }
  } catch (error) {
    console.error('加载人员列表失败:', error);
    teamUserList.value = [];
  } finally {
    teamUserLoading.value = false;
  }
};

// 判断人员是否已选中
const isTeamMemberSelected = (user: TeamUserInfo): boolean => {
  const code = getTeamUserCode(user);
  return !!code && !!tempExecutionTeam.value[code];
};

// 切换人员选中状态
const toggleTeamMember = (user: TeamUserInfo) => {
  const code = getTeamUserCode(user);
  const name = getTeamUserName(user);
  if (!code) {
    ElMessage.warning('当前人员缺少编码，无法选择');
    return;
  }

  if (tempExecutionTeam.value[code]) {
    const { [code]: _, ...rest } = tempExecutionTeam.value;
    tempExecutionTeam.value = rest;
  } else {
    if (memberSelectTarget.value === 'manager') {
      tempExecutionTeam.value = { [code]: name };
    } else {
      tempExecutionTeam.value = { ...tempExecutionTeam.value, [code]: name };
    }
  }
};

// 确认人员选择
const confirmTeamSelection = () => {
  if (!currentForm.value) return;
  if (memberSelectTarget.value === 'manager') {
    const [code, name] = Object.entries(tempExecutionTeam.value)[0] || [];
    currentForm.value.projectManagerCode = code || '';
    currentForm.value.projectManager = name || '';
  } else if (memberSelectTarget.value === 'assistant') {
    currentForm.value.projectAssistant = { ...tempExecutionTeam.value };
  } else {
    currentForm.value.executionTeam = { ...tempExecutionTeam.value };
  }
  teamDialogVisible.value = false;
  ElMessage.success(`已选择 ${Object.keys(tempExecutionTeam.value).length} 名人员`);
};

// ========== 主责部门选择弹框方法 ==========
const openDeptDialog = async () => {
  deptSelectedNode.value = null;
  deptFilterText.value = '';
  deptDialogVisible.value = true;
  if (deptTreeData.value.length === 0) {
    await loadDeptTree();
  }
  nextTick(() => {
    deptTreeRef.value?.filter('');
  });
};

const loadDeptTree = async () => {
  try {
    deptTreeLoading.value = true;
    const res: Record<string, unknown> = await PermissionManagement.getDepartmentTree({ pid: '0' });
    const resAny = res as Record<string, unknown>;
    if (resAny && (resAny as Record<string, unknown>).status === 200 && (resAny as Record<string, unknown>).success) {
      const response = (resAny as Record<string, unknown>).response as Record<string, unknown>;
      if (response?.children && Array.isArray(response.children)) {
        deptTreeData.value = response.children as DepartmentNode[];
      } else {
        deptTreeData.value = response ? [response as unknown as DepartmentNode] : [];
      }
    } else {
      deptTreeData.value = [];
    }
  } catch (error) {
    console.error('加载部门树失败:', error);
    deptTreeData.value = [];
  } finally {
    deptTreeLoading.value = false;
  }
};

const handleDeptNodeClick = (data: DepartmentNode) => {
  deptSelectedNode.value = data;
};

const handleDeptTreeFilter = () => {
  deptTreeRef.value?.filter(deptFilterText.value);
};

const filterDeptNode = (value: string, data: DepartmentNode) => {
  if (!value) return true;
  return data.label.includes(value);
};

const confirmDeptSelection = () => {
  if (!currentForm.value) return;
  if (!deptSelectedNode.value) {
    ElMessage.warning('请先选择一个部门');
    return;
  }
  currentForm.value.responsibleDepartment = deptSelectedNode.value.label;
  deptDialogVisible.value = false;
  ElMessage.success(`已选择主责部门：${deptSelectedNode.value.label}`);
};

// 移除执行团队成员
const removeTeamMember = (code: string) => {
  if (!currentForm.value) return;
  const { [code]: _, ...rest } = currentForm.value.executionTeam;
  currentForm.value.executionTeam = rest;
};

// 移除项目助理
const removeAssistantMember = (code: string) => {
  if (!currentForm.value) return;
  const { [code]: _, ...rest } = currentForm.value.projectAssistant;
  currentForm.value.projectAssistant = rest;
};

// 项目助理列表（与执行团队格式一致）
const assistantList = computed(() => {
  if (!currentForm.value) return [];
  const pa = currentForm.value.projectAssistant;
  if (!pa || typeof pa !== 'object') return [];
  return Object.entries(pa).map(([code, name]) => ({ code, name }));
});

// 格式化执行团队显示文本
const executionTeamList = computed(() => {
  if (!currentForm.value) return [];
  const et = currentForm.value.executionTeam;
  if (!et || typeof et !== 'object') return [];
  return Object.entries(et).map(([code, name]) => ({ code, name }));
});

// 计算已选中项目的完整数据（用于外层标签展示）
// 注意：外层标签不应该依赖 projectListData，因为弹框内筛选会改变 projectListData
// 应该始终使用 selectedProjectsFullData 来展示已确认的选择
const selectedProjectsData = computed(() => {
  if (!Array.isArray(selectedProjectIds.value) || selectedProjectIds.value.length === 0) {
    return []
  }
  const projectsById = new Map<string, any>();
  selectedProjectsFullData.value.forEach((item) => {
    const itemId = getProjectItemId(item);
    if (itemId !== undefined && itemId !== null) {
      projectsById.set(getProjectIdKey(itemId), item);
    }
  });
  return selectedProjectIds.value
    .map((id) => projectsById.get(getProjectIdKey(id)))
    .filter(Boolean);
})

const handleProjectTagDragStart = (index: number, event: DragEvent) => {
  if (!isEditMode.value) return;
  draggedProjectIndex.value = index;
  event.dataTransfer?.setData('text/plain', String(index));
  if (event.dataTransfer) event.dataTransfer.effectAllowed = 'move';
};

const handleProjectTagDrop = (targetIndex: number) => {
  const sourceIndex = draggedProjectIndex.value;
  if (sourceIndex === null || sourceIndex === targetIndex) {
    draggedProjectIndex.value = null;
    return;
  }

  const orderedIds = [...selectedProjectIds.value];
  const [movedId] = orderedIds.splice(sourceIndex, 1);
  orderedIds.splice(targetIndex, 0, movedId);
  selectedProjectIds.value = orderedIds;
  draggedProjectIndex.value = null;
};


// 计算弹框内选中项目的完整数据（用于弹框内表格的defaultSelection）
const tempSelectedProjectsData = computed(() => {
  if (!Array.isArray(tempSelectedProjectIds.value) || tempSelectedProjectIds.value.length === 0) {
    return []
  }
  return projectListData.value.filter(item => {
    const itemId = item.Id || item.id
    return tempSelectedProjectIds.value.includes(itemId)
  })
})

// 计算弹框内选中项目包的完整数据
const tempSelectedPackagesData = computed(() => {
  if (!Array.isArray(tempSelectedPackageIds.value) || tempSelectedPackageIds.value.length === 0) {
    return []
  }
  return packageListData.value.filter(item => {
    const itemId = item.Id || item.id
    return tempSelectedPackageIds.value.includes(itemId)
  })
})

// 图片/PDF预览相关
const imagePreviewVisible = ref(false);
const previewImageUrl = ref('');
const previewIsPdf = ref(false);

// 判断是否为PDF文件
const isPdfFile = (file: UploadUserFile): boolean => {
  const name = file.name?.toLowerCase() || '';
  const type = (file as any).raw?.type || '';
  return name.endsWith('.pdf') || type === 'application/pdf';
};

const isSupportedDrawingFile = (file: { name?: string; type?: string; raw?: File }): boolean => {
  const name = file.name?.toLowerCase() || '';
  const type = file.raw?.type || file.type || '';
  return name.endsWith('.pdf') || type === 'application/pdf'
    || type.startsWith('image/')
    || /\.(jpe?g|png|bmp|webp|gif)$/i.test(name);
};

// 生成PDF首页缩略图
const generatePdfThumbnail = async (file: File): Promise<string> => {
  try {
    const pdfjsLib = await getPdfjsLib();
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);

    // 设置缩略图尺寸
    const scale = 0.5;
    const viewport = page.getViewport({ scale });

    // 创建 canvas
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d')!;
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    // 渲染 PDF 页面到 canvas
    await page.render({
      canvasContext: context,
      viewport: viewport
    }).promise;

    // 转换为图片 URL
    return canvas.toDataURL('image/png');
  } catch (error) {
    console.error('生成PDF缩略图失败:', error);
    return '';
  }
};

// 预览图片/PDF
const previewImage = async (file: UploadUserFile) => {
  try {
    const isPdf = (file as any).isPdf || isPdfFile(file);
    previewIsPdf.value = isPdf;

    // PDF 文件使用 pdfUrl 预览
    if (isPdf && (file as any).pdfUrl) {
      previewImageUrl.value = (file as any).pdfUrl;
      imagePreviewVisible.value = true;
      return;
    }

    // 如果已有url，直接使用
    if ((file as any).url) {
      previewImageUrl.value = (file as any).url;
      imagePreviewVisible.value = true;
      return;
    }

    // 优先使用后端下载接口（基于服务器返回的编码）
    const serverCode = (file as any).serverCode || (file as any).code || (file as any).内容;
    if (serverCode) {
      const url = await fetchImageContent(serverCode);
      if (url) {
        previewImageUrl.value = url;
        // 更新文件的url属性，下次直接使用
        (file as any).url = url;
        imagePreviewVisible.value = true;
        return;
      }
    }

    // 退化处理：使用已有原始文件（本地上传的文件）
    if ((file as any).raw) {
      previewImageUrl.value = URL.createObjectURL((file as any).raw);
      imagePreviewVisible.value = true;
      return;
    }
    ElMessage.warning('无法预览该文件');
  } catch (e) {
    console.error('预览文件失败:', e);
    ElMessage.error('预览文件失败');
  }
};

// 获取图片内容（用于缩略图和预览）
const fetchImageContent = async (serverCode: string): Promise<string | null> => {
  if (!serverCode) return null;

  // Check cache first
  if (thumbnailCache.has(serverCode)) {
    return thumbnailCache.get(serverCode)!;
  }

  try {
    const res: any = await ParameterSettings.operatingProjectDownload({ fileName: serverCode });
    let imageUrl = '';

    if (res instanceof Blob) {
      imageUrl = URL.createObjectURL(res);
    } else {
      // 尝试从不同结构中获取数据
      const data = res?.response || res?.data || res;

      if (data instanceof Blob) {
        imageUrl = URL.createObjectURL(data);
      } else if (typeof data === 'string') {
        if (data.startsWith('http') || data.startsWith('blob:') || data.startsWith('data:')) {
          imageUrl = data;
        } else {
          imageUrl = `data:image/jpeg;base64,${data}`;
        }
      }
    }

    if (imageUrl) {
      thumbnailCache.set(serverCode, imageUrl);
      return imageUrl;
    }
  } catch (e) {
    console.warn(`图片加载失败 (${serverCode}):`, e);
  }
  return null;
};

const getDownloadBlob = (response: any): Blob | null => {
  if (response instanceof Blob) return response;
  const data = response?.response || response?.data || response;
  return data instanceof Blob ? data : null;
};

const isPdfBlob = async (blob: Blob): Promise<boolean> => {
  if (blob.type.toLowerCase().includes('pdf')) return true;
  const header = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
  return String.fromCharCode(...header) === '%PDF-';
};

// 刷新详情时服务端只返回文件编码，需根据实际文件内容重新识别 PDF 并生成缩略图。
const loadFloorDocumentPreview = async (file: any): Promise<void> => {
  const serverCode = String(file?.serverCode || '');
  if (!serverCode) return;

  const response = await ParameterSettings.operatingProjectDownload({ fileName: serverCode });
  const blob = getDownloadBlob(response);
  if (!blob) {
    const url = await fetchImageContent(serverCode);
    if (url) file.url = url;
    return;
  }

  if (await isPdfBlob(blob)) {
    file.isPdf = true;
    file.pdfUrl = URL.createObjectURL(blob);
    file.thumbnailUrl = await generatePdfThumbnail(
      new File([blob], file.name || 'drawing.pdf', { type: blob.type || 'application/pdf' })
    );
    if (!String(file.name || '').toLowerCase().endsWith('.pdf')) {
      file.name = `${String(file.name || '图纸').replace(/\.[^.]+$/, '')}.pdf`;
    }
    return;
  }

  file.isPdf = false;
  file.url = URL.createObjectURL(blob);
  thumbnailCache.set(serverCode, file.url);
};

// 打开弹窗并加载检测项目数据
const openProjectDialog = async () => {
  // 打开弹框时，将当前已确认的选择复制到临时变量
  tempSelectedProjectIds.value = [...selectedProjectIds.value];
  tempSelectedPackageIds.value = [...selectedPackageIds.value];

  dialogVisible.value = true;

  // 根据当前Tab加载对应的数据
  if (activeTab.value === 'package') {
    if (packageListData.value.length === 0) {
      await loadPackageList();
    }
  } else {
    if (projectListData.value.length === 0) {
      await loadProjectList();
    }
  }
};

// 加载检测项目列表数据
const loadProjectList = async () => {
  try {
    projectListLoading.value = true;
    const res = await ParameterSettings.parameterSettingsListIndex({}, projectFilterParams.value);

    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      projectListData.value = Array.isArray(res.response.data) ? res.response.data : [];
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        projectTableModel.value = res.response.model;
      } else {
        projectTableModel.value = undefined;
      }
    } else {
      projectListData.value = [];
      projectTableModel.value = undefined;
    }
  } catch (error) {
    console.error('加载检测项目列表失败:', error);
    projectListData.value = [];
    ElMessage.error('加载检测项目列表失败');
  } finally {
    projectListLoading.value = false;
  }
};
// 处理检测项目筛选
const handleProjectFilter = async (filters: any[]) => {
  // 保存当前的临时选择状态
  const currentSelection = [...tempSelectedProjectIds.value];
  projectFilterParams.value = filters;
  await loadProjectList();
  // 确保选择状态在数据加载后得到恢复
  await nextTick();
  tempSelectedProjectIds.value = currentSelection;
};
// 处理检测项目选择变化（弹框内）
const handleProjectSelectionChange = (selection: any[]) => {
  // 当前页已选项按勾选先后追加；其他页已选项保持原有顺序。
  const currentPageIds = new Set(projectListData.value
    .map((item) => getProjectItemId(item))
    .filter((id) => id !== undefined && id !== null)
    .map(getProjectIdKey));
  const selectedIds = selection
    .map((item) => getProjectItemId(item))
    .filter((id) => id !== undefined && id !== null);
  const selectedIdKeys = new Set(selectedIds.map(getProjectIdKey));
  const nextIds = tempSelectedProjectIds.value.filter((id) => {
    const key = getProjectIdKey(id);
    return !currentPageIds.has(key) || selectedIdKeys.has(key);
  });
  const existingIdKeys = new Set(nextIds.map(getProjectIdKey));

  selectedIds.forEach((id) => {
    const key = getProjectIdKey(id);
    if (!existingIdKeys.has(key)) {
      nextIds.push(id);
      existingIdKeys.add(key);
    }
  });

  tempSelectedProjectIds.value = nextIds;
};

// 加载检测项目包列表数据
const loadPackageList = async () => {
  try {
    packageListLoading.value = true;
    const res = await ParameterSettings.detectionPackageListIndex({}, packageFilterParams.value);

    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      packageListData.value = Array.isArray(res.response.data) ? res.response.data : [];
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        packageTableModel.value = res.response.model;
      } else {
        packageTableModel.value = undefined;
      }
    } else {
      packageListData.value = [];
      packageTableModel.value = undefined;
    }
  } catch (error) {
    console.error('加载检测项目包列表失败:', error);
    packageListData.value = [];
    ElMessage.error('加载检测项目包列表失败');
  } finally {
    packageListLoading.value = false;
  }
};

// 处理检测项目包筛选
const handlePackageFilter = async (filters: any[]) => {
  // 保存当前的临时选择状态
  const currentSelection = [...tempSelectedPackageIds.value];
  packageFilterParams.value = filters;
  await loadPackageList();
  // 确保选择状态在数据加载后得到恢复
  await nextTick();
  tempSelectedPackageIds.value = currentSelection;
};

// 处理检测项目包选择变化（弹框内）
const handlePackageSelectionChange = (selection: any[]) => {
  // 只更新临时选择，不影响外层标签显示
  tempSelectedPackageIds.value = selection.map(item => item.Id || item.id);
};

// 查看检测项目包详情
const handlePackageDetail = async (row: any) => {
  try {
    packageDetailLoading.value = true;
    currentPackageDetail.value = row;
    packageDetailVisible.value = true;

    // 调用接口获取项目包包含的检测项目列表
    const packageId = row.Id || row.id;
    const res: any = await ParameterSettings.detectionPackageById({ id: packageId });

    if (res && res.status === 200 && res.success && res.response) {
      // 解析检测项目列表 - 优先使用 检测项目集合
      if (res.response.检测项目集合 && Array.isArray(res.response.检测项目集合)) {
        packageDetailProjects.value = res.response.检测项目集合;
      } else if (res.response.检测项目列表 && Array.isArray(res.response.检测项目列表)) {
        packageDetailProjects.value = res.response.检测项目列表;
      } else if (res.response.projectList && Array.isArray(res.response.projectList)) {
        packageDetailProjects.value = res.response.projectList;
      } else {
        packageDetailProjects.value = [];
      }

      // 提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        packageDetailProjectsModel.value = res.response.model;
      } else {
        packageDetailProjectsModel.value = undefined;
      }
    } else {
      packageDetailProjects.value = [];
      ElMessage.warning('未能获取项目包详情');
    }
  } catch (error) {
    console.error('加载项目包详情失败:', error);
    packageDetailProjects.value = [];
    ElMessage.error('加载项目包详情失败');
  } finally {
    packageDetailLoading.value = false;
  }
};

// Tab切换处理
const handleTabChange = async (tabName: string) => {
  if (tabName === 'package' && packageListData.value.length === 0) {
    await loadPackageList();
  } else if (tabName === 'project' && projectListData.value.length === 0) {
    await loadProjectList();
  }
};
// 关闭弹窗
const closeProjectDialog = (reset = false) => {
  dialogVisible.value = false;
  // 始终重置筛选条件、排序和数据列表，确保下次打开弹窗时显示完整列表
  projectFilterParams.value = [];
  projectListData.value = [];
  packageFilterParams.value = [];
  packageListData.value = [];

  if (reset) {
    // 重置选中项（仅在取消时）
    selectedProjectIds.value = [];
    selectedPackageIds.value = [];
  }
};
// 确认选择检测项目
const confirmProjectSelection = async () => {
  try {
    // 1. 先处理选中的项目包，获取包内的检测项目
    const projectIdsFromPackages: any[] = [];
    const projectsDataFromPackages: any[] = [];

    if (tempSelectedPackageIds.value.length > 0) {
      // 遍历每个选中的项目包，获取其包含的检测项目
      for (const packageId of tempSelectedPackageIds.value) {
        try {
          const res = await ParameterSettings.detectionPackageById({ id: packageId });
          if (res && res.status === 200 && res.success && res.response) {
            const projects = res.response.检测项目集合 || res.response.检测项目列表 || res.response.projectList || [];
            projects.forEach((project: any) => {
              const projectId = project.Id || project.id;
              // 去重：只添加不在列表中的项目
              if (projectId && !projectIdsFromPackages.includes(projectId)) {
                projectIdsFromPackages.push(projectId);
                projectsDataFromPackages.push(project);
              }
            });
          }
        } catch (error) {
          console.error(`获取项目包 ${packageId} 详情失败:`, error);
        }
      }
    }

    // 2. 合并直接选择的项目和从项目包展开的项目，保留直接勾选的先后顺序。
    const allProjectIds: any[] = [];
    const allProjectIdKeys = new Set<string>();
    const addProjectId = (id: any) => {
      if (id === undefined || id === null) return;
      const key = getProjectIdKey(id);
      if (!allProjectIdKeys.has(key)) {
        allProjectIds.push(id);
        allProjectIdKeys.add(key);
      }
    };
    tempSelectedProjectIds.value.forEach(addProjectId);
    projectIdsFromPackages.forEach(addProjectId);

    const projectsById = new Map<string, any>();
    [...selectedProjectsFullData.value, ...projectListData.value, ...projectsDataFromPackages].forEach((project) => {
      const projectId = getProjectItemId(project);
      if (projectId !== undefined && projectId !== null) {
        projectsById.set(getProjectIdKey(projectId), project);
      }
    });
    const allProjectsData = allProjectIds
      .map((id) => projectsById.get(getProjectIdKey(id)))
      .filter(Boolean);

    // 3. 保存最终结果（只保存项目，不保存项目包）
    selectedProjectIds.value = allProjectIds;
    selectedProjectsFullData.value = allProjectsData;
    selectedPackageIds.value = []; // 清空项目包ID，因为已经展开为项目了
    selectedPackagesFullData.value = [];

    ElMessage.success(`选择完成，共 ${selectedProjectIds.value.length} 个原始记录`);
    closeProjectDialog(false);
  } catch (error) {
    console.error('确认选择失败:', error);
    ElMessage.error('选择失败，请重试');
  }
};

// 移除选中的检测项目
const removeSelectedProject = (projectId: any) => {
  const projectIdKey = getProjectIdKey(projectId);
  const index = selectedProjectIds.value.findIndex((id) => getProjectIdKey(id) === projectIdKey);
  if (index > -1) {
    selectedProjectIds.value.splice(index, 1);
    selectedProjectsFullData.value = selectedProjectsFullData.value.filter((project) => {
      return getProjectIdKey(getProjectItemId(project)) !== projectIdKey;
    });
    ElMessage.success('已移除该原始记录');
  }
};

// 生成带地下层的完整楼层号（升序），如地下 2 层 + 地上 3 层 => [-2, -1, 1, 2, 3]
const getBuildingFloorNumbers = (floors: number, basementFloors: number): number[] => {
  const above = Math.max(0, Math.floor(Number(floors) || 0));
  const below = Math.max(0, Math.floor(Number(basementFloors) || 0));
  const numbers: number[] = [];
  for (let i = below; i >= 1; i--) numbers.push(-i);
  for (let i = 1; i <= above; i++) numbers.push(i);
  return numbers;
};

// 从图纸文件名中解析楼层号，如 -2.jpg、-1.jpg、1.jpg、2.pdf => -2 / -1 / 1 / 2
const parseDrawingFloorFromName = (fileName: string): number | null => {
  const base = String(fileName || '').trim();
  const match = /^(-?\d+)/.exec(base);
  if (!match) return null;
  return parseInt(match[1], 10);
};

const ensureFloorDocumentsStructure = (floors: number, existing: FloorDocument[] = [], basementFloors = 0) => {
  // 创建一个映射来存储现有的楼层文档
  const existingMap = new Map<number, FloorDocument>();
  existing.forEach(doc => {
    existingMap.set(doc.floorNumber, {
      floorNumber: doc.floorNumber,
      files: Array.isArray(doc.files) ? doc.files : []
    });
  });

  // 按“地下层在前、地上层在后”的升序为每一层创建或保留文档
  const documents: FloorDocument[] = [];
  for (const floorNumber of getBuildingFloorNumbers(floors, basementFloors)) {
    if (existingMap.has(floorNumber)) {
      // 如果该楼层已存在文档，则保留它
      documents.push(existingMap.get(floorNumber)!);
    } else {
      // 否则创建一个新的空文档
      documents.push({
        floorNumber,
        files: []
      });
    }
  }
  return documents;
};

const initializeBuildingSelection = (form: FormData | null) => {
  if (!form) {
    selectedBuildingIndex.value = null;
    selectedFloorIndex.value = null;
    return;
  }

  if (!Array.isArray(form.buildings)) {
    form.buildings = [];
  }

  let selectedIndex = form.buildings.findIndex(b => b.selected);
  if (selectedIndex === -1 && form.buildings.length > 0) {
    selectedIndex = 0;
    form.buildings[0].selected = true;
  }

  selectedBuildingIndex.value = selectedIndex >= 0 ? selectedIndex : null;

  if (selectedBuildingIndex.value !== null) {
    const building = form.buildings[selectedBuildingIndex.value];
    building.floorDocuments = ensureFloorDocumentsStructure(building.floors, building.floorDocuments, building.basementFloors);
    selectedFloorIndex.value = building.floorDocuments.length > 0 ? 0 : null;
  } else {
    selectedFloorIndex.value = null;
  }
};

// 辅助函数：查找表单列表中的项索引
const findFormIndex = (row: any): number => {
  return formList.value.findIndex((item: any) => {
    if (row.Id !== undefined && item.Id !== undefined) return item.Id === row.Id;
    if (row.id !== undefined && item.id !== undefined) return item.id === row.id;
    return item === row;
  });
};

// 左侧列表数据（直接使用接口返回的数据）
const formListData = computed(() => {
  return formList.value;
});

const activeFormRowKey = computed(() => {
  if (activeFormIndex.value < 0 || activeFormIndex.value >= formList.value.length) return null;
  const item = formList.value[activeFormIndex.value];
  return item?.Id ?? item?.id ?? null;
});

const findFormItem = (targetId?: number | string, targetName?: string): any => {
  if (targetId) {
    const targetIdText = String(targetId);
    const foundById = formList.value.find((item: any) => String(item.Id ?? item.id ?? '') === targetIdText);
    if (foundById) return foundById;
  }
  if (targetName) {
    return formList.value.find((item: any) => item.名称 === targetName || item.name === targetName);
  }
  return null;
};

// 处理查看按钮点击（设置为查看模式）
const handleFormEdit = async (row: any) => {
  // 每次点击查看都重新加载数据，确保获取最新的数据
  try {
    loading.value = true;
    await handleFormSelect(row);
  } finally {
    loading.value = false;
  }
  isEditMode.value = false; // 设置为查看模式，不可编辑
  ElMessage.success('已进入查看模式');
};

// 进入编辑模式
const enterEditMode = () => {
  if (!canEnterEditMode.value) {
    ElMessage.warning('当前记录不允许编辑');
    return;
  }
  isEditMode.value = true;
  ElMessage.success('已进入编辑模式');
};

// 退出编辑模式
const exitEditMode = () => {
  ElMessageBox.confirm('确定要取消编辑吗？未保存的修改将丢失', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    isEditMode.value = false;
    // 重新加载当前表单数据
    const currentItem = formList.value[activeFormIndex.value];
    if (currentItem) {
      const itemId = currentItem.Id || currentItem.id;
      if (itemId) {
        handleFormSelect(currentItem);
      }
    }
    ElMessage.success('已退出编辑模式');
  }).catch(() => { /* cancelled */ });
};

// 处理删除按钮点击
const handleFormDelete = (row: any) => {
  const index = findFormIndex(row);
  if (index >= 0) deleteForm(index);
};

// 加载表单列表数据（仅用于左侧列表展示）
const loadFormList = async () => {
  try {
    listLoading.value = true;
    // 构建分页参数
    const paginationData = {
      page: formPagination.value.page,
      intPageSize: formPagination.value.pageSize,
      key: quickKeyword.value.trim()
    };
    const res = await ParameterSettings.operatingProjectListIndex(paginationData, filterParams.value);

    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      formList.value = Array.isArray(res.response.data) ? res.response.data : [];
      // 更新总数 - 使用dataCount字段
      formPagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        tableModel.value = res.response.model;
      } else {
        tableModel.value = undefined;
      }
    } else {
      formList.value = [];
      tableModel.value = undefined;
      formPagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载表单列表失败:', error);
    formList.value = [];
  } finally {
    listLoading.value = false;
  }
};

const handleQuickQuery = () => {
  formPagination.value.page = 1;
  loadFormList();
};

const handleQuickSync = async () => {
  try {
    quickSyncLoading.value = true;
    const res = await ParameterSettings.operatingProjectQuickSync({
      key: quickKeyword.value.trim()
    });

    if (res && res.status === 200 && res.success) {
      ElMessage.success(res.msg || '快速同步成功');
      formPagination.value.page = 1;
      await loadFormList();
    } else {
      ElMessage.error(res?.msg || '快速同步失败');
    }
  } catch (error) {
    console.error('快速同步失败:', error);
    ElMessage.error('快速同步失败');
  } finally {
    quickSyncLoading.value = false;
  }
};

// 筛选处理函数
const handleFilter = (filters: any[]) => {
  filterParams.value = filters;
  formPagination.value.page = 1; // 筛选时重置到第一页
  loadFormList(); // 重新加载数据
};

// 分页器事件处理
const handleFormPageChange = (page: number) => {
  formPagination.value.page = page;
  loadFormList();
};

const handleFormPageSizeChange = (pageSize: number) => {
  formPagination.value.pageSize = pageSize;
  formPagination.value.page = 1; // 改变页大小时重置到第一页
  loadFormList();
};

// 解析JSON字段：优先使用对象，退化为JSON字符串解析
const parseJsonField = (objField: unknown, jsonField: unknown): Record<string, string> => {
  // 优先使用对象字段
  if (objField && typeof objField === 'object' && Object.keys(objField as Record<string, unknown>).length > 0) {
    return objField as Record<string, string>;
  }
  // 退化为JSON字符串解析
  if (jsonField && typeof jsonField === 'string' && jsonField !== '{}') {
    try {
      const parsed = JSON.parse(jsonField);
      if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
        return parsed as Record<string, string>;
      }
    } catch { /* ignore parse error */ }
  }
  return {};
};

const loadFormDetail = async (item: any) => {
  // 这里应该根据实际返回的数据结构进行解析
  const buildings: Building[] = [];

  // 如果有楼栋数据，则解析
  if (item.建筑列表 && Array.isArray(item.建筑列表)) {
    item.建筑列表.forEach((b: any, idx: number) => {
      const floors = parseInt(b.层数) || 1;
      const basementFloors = parseInt(b.地下层数) || 0;
      const floorDocs: FloorDocument[] = [];

      // 修改这里：正确按照楼层号组织图纸数据
      if (Array.isArray(b.图纸包)) {
        // 创建一个映射，将图纸按楼层号分组
        const floorDrawingMap = new Map<number, any[]>();

        b.图纸包.forEach((doc: any) => {
          // 图纸包中的图纸携带“层数”字段时以其为准（可为 -1、-2 等地下层）
          const drawingFloor = Number(doc?.层数);
          // 没有层数标记时按图纸包原有顺序对应楼层（兼容旧数据：顺序即地上楼层）
          const floorIndex = !Number.isNaN(drawingFloor)
            ? drawingFloor
            : b.图纸包.indexOf(doc) + 1; // 从1开始计数

          if (!floorDrawingMap.has(floorIndex)) {
            floorDrawingMap.set(floorIndex, []);
          }

          // 现在后端返回内容为文件编码/文件名，保存为 serverCode
          if (doc.内容) {
            const serverCode = String(doc.内容);
            const isPdf = serverCode.toLowerCase().endsWith('.pdf');
            const fileName = isPdf
              ? `${floorIndex}层图纸_${doc.Id || Date.now()}.pdf`
              : `${floorIndex}层图纸_${doc.Id || Date.now()}.jpg`;
            const fileObj = {
              name: fileName,
              uid: genFileId(),
              status: 'success',
              serverCode,
              url: '',
              loading: !isPdf,
              isPdf
            };

            floorDrawingMap.get(floorIndex)?.push(fileObj);
          }
        });

        // 将分组后的文件添加到对应楼层文档中
        floorDrawingMap.forEach((files, floorNumber) => {
          floorDocs.push({
            floorNumber: floorNumber,
            files: files
          });
        });
      }

      buildings.push({
        id: b.Id || Date.now().toString() + Math.random(),
        code: b.报告编号 || b.编码 || '',
        name: b.名称 || '',
        floors,
        basementFloors,
        selected: idx === 0,
        floorDocuments: ensureFloorDocumentsStructure(floors, floorDocs, basementFloors),
        editing: false
      });
    });
  }

  // 获取建筑个数，优先使用接口返回的，否则使用建筑数组长度
  const buildingCount = item.buildingCount || item.建筑个数 || item.建筑列表?.length || 0;

  // 如果没有建筑数据但有建筑个数，自动生成建筑
  if (buildings.length === 0 && buildingCount > 0) {
    for (let i = 1; i <= buildingCount; i++) {
      buildings.push({
        id: Date.now().toString() + i,
        code: '',
        name: `${i}号楼`,
        floors: 1,
        basementFloors: 0,
        selected: i === 1,
        floorDocuments: ensureFloorDocumentsStructure(1),
        editing: false
      });
    }
  }

  // 处理检测项目列表
  const projectIds: any[] = [];
  const projectsData: any[] = [];
  if (item.检测项目列表 && Array.isArray(item.检测项目列表)) {
    item.检测项目列表.forEach((project: any) => {
      const projectId = project.Id || project.id;
      if (projectId) {
        projectIds.push(projectId);
        // 保存项目的完整数据，用于查看模式显示
        projectsData.push(project);
      }
    });
  }

  return {
    id: item.id || item.Id,
    code: item.code || item.编码 || '',
    name: item.name || item.名称 || '',
    projectManagerCode: item.projectManagerCode || item.项目负责人code || item.项目负责人Code || item.项目负责人codejson || '',
    projectManager: item.projectManager || item.项目负责人 || '',
    responsibleDepartment: item.responsibleDepartment || item.主责部门 || '',
    status: item.status || item.状态 || '',
    startTime: item.startTime || item.项目开始时间 || null,
    remark: item.remark || item.说明 || '',
    buildingCount: buildingCount,
    buildings: buildings,
    projectIds: projectIds,
    projectsData: projectsData,
    // 解析项目助理：接口返回为对象或JSON字符串
    projectAssistant: parseJsonField(item.项目助理, item.项目助理codejson),
    // 解析执行团队：接口返回为对象或JSON字符串
    executionTeam: parseJsonField(item.执行团队, item.执行团队codejson)
  };
};

// 组件挂载后加载数据
onMounted(() => {
  loadFormList();
  // 设置左侧面板默认宽度为容器的一半
  nextTick(() => {
    if (mainContentRef.value) {
      leftPanelWidth.value = mainContentRef.value.getBoundingClientRect().width / 2;
    }
  });
});

// 添加新表单
const addNewForm = () => {
  const formName = `表单${formList.value.length + 1}`;
  const newForm = createEmptyForm();
  newForm.name = formName;

  // 创建列表项数据结构（用于左侧列表显示）
  const newListItem: any = {
    名称: formName,
    name: formName,
    编码: `FD${String(formList.value.length + 1).padStart(4, '0')}`,
    _isNew: true,
    _formData: newForm
  };

  formList.value.push(newListItem);
  activeFormIndex.value = formList.value.length - 1;
  currentForm.value = newForm;
  currentFormEditable.value = true;
  selectedProjectIds.value = [];
  resetProjectFiles();
  isEditMode.value = true;

  ElMessage.success('新增表单成功');
};

// 刷新当前表单的所有缩略图
const refreshThumbnails = async () => {
  if (!currentForm.value || !currentForm.value.buildings) return;

  const tasks: Promise<void>[] = [];

  currentForm.value.buildings.forEach(building => {
    if (building.floorDocuments) {
      building.floorDocuments.forEach(doc => {
        if (doc.files) {
          doc.files.forEach((file: any) => {
            if (file.serverCode && !file.url && !file.pdfUrl) {
              // 已确认的图片可直接使用缓存；PDF 和未知类型文件需下载后重新识别。
              if (!file.isPdf && thumbnailCache.has(file.serverCode)) {
                file.url = thumbnailCache.get(file.serverCode)!;
                file.loading = false;
              } else {
                file.loading = true;
                tasks.push(
                  loadFloorDocumentPreview(file).catch((error) => {
                    console.warn(`图纸缩略图加载失败 (${file.serverCode}):`, error);
                  }).finally(() => {
                    file.loading = false;
                    const fileIndex = doc.files.indexOf(file);
                    if (fileIndex !== -1) {
                      doc.files.splice(fileIndex, 1, { ...file });
                    }
                  })
                );
              }
            } else {
              // 如果已经有url或者不需要加载，确保loading为false
              file.loading = false;
            }
          });
        }
      });
    }
  });

  if (tasks.length > 0) {
    await Promise.all(tasks);
  }
};

// 选择表单
const handleFormSelect = async (row: any) => {
  const index = findFormIndex(row);

  if (index >= 0) {
    resetProjectFiles();
    activeFormIndex.value = index;
    const item = formList.value[index];

    // 如果是新添加的表单且有_formData，直接使用
    if (item._isNew && item._formData) {
      currentForm.value = item._formData;
      currentFormEditable.value = true;
      initializeBuildingSelection(currentForm.value);
      return;
    }

    // 获取ID（支持 Id 或 id 字段）
    const itemId = item.Id || item.id;

    // 如果有ID，调用详情接口加载数据
    if (itemId) {
      try {
        loading.value = true;
        // 调用详情接口
        const res = await ParameterSettings.operatingProjectById({ id: itemId });

        if (res && res.status === 200 && res.success && res.response) {
          currentFormEditable.value = toEditableFlag((res as any).editable,
            toEditableFlag((res as any).response?.editable, false));
          // 解析详情数据
          const formData = await loadFormDetail(res.response);
          if (!formData.id) {
            formData.id = itemId;
          }
          currentForm.value = formData;
          // 设置已选中的检测项目ID和完整数据
          if (formData.projectIds && Array.isArray(formData.projectIds)) {
            selectedProjectIds.value = [...formData.projectIds];
          } else {
            selectedProjectIds.value = [];
          }
          if (formData.projectsData && Array.isArray(formData.projectsData)) {
            selectedProjectsFullData.value = [...formData.projectsData];
          } else {
            selectedProjectsFullData.value = [];
          }
          initializeBuildingSelection(currentForm.value);
          // 刷新缩略图，使用 setTimeout 确保在全局 loading 消失后才开始加载图片，避免阻塞界面交互
          setTimeout(() => {
            refreshThumbnails();
          }, 50);
          loadProjectFiles(String(itemId), false);
          ElMessage.success('数据加载成功');
        } else {
          ElMessage.error('数据加载失败');
          currentFormEditable.value = false;
          currentForm.value = createEmptyForm();
          selectedProjectIds.value = [];
          initializeBuildingSelection(currentForm.value);
        }
      } catch (error) {
        console.error('加载表单详情失败:', error);
        ElMessage.error('数据加载失败');
        currentFormEditable.value = false;
        currentForm.value = createEmptyForm();
        selectedProjectIds.value = [];
        initializeBuildingSelection(currentForm.value);
      } finally {
        loading.value = false;
      }
    } else {
      // 如果没有ID（可能是新增的表单），检查是否已有完整数据
      currentFormEditable.value = toEditableFlag(item.editable, true);
      if (item.buildings) {
        // 如果已有完整数据，直接使用
        currentForm.value = item as FormData;
      } else {
        currentForm.value = createEmptyForm();
      }
      selectedProjectIds.value = [];
      initializeBuildingSelection(currentForm.value);
    }
  }
};

// 删除表单
const deleteForm = async (index: number) => {
  const item = formList.value[index];
  if (!item) return;

  const itemId = item.Id || item.id;

  // 如果是新建的表单（没有ID），直接从前端删除
  if (!itemId || item._isNew) {
    ElMessageBox.confirm('确定要删除这个表单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      formList.value.splice(index, 1);
      if (activeFormIndex.value === index) {
        activeFormIndex.value = -1;
        currentForm.value = null;
        currentFormEditable.value = false;
      }
      ElMessage.success('删除成功');
    }).catch(() => { /* cancelled */ });
    return;
  }

  // 有ID的情况，调用后端API删除
  ElMessageBox.confirm('确定要删除这个表单吗？删除后无法恢复', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    try {
      // 调用删除接口
      const res = await ParameterSettings.operatingProjectDelete({ id: itemId });

      if (res && res.status === 200 && res.success) {
        const isDeletingActive = activeFormIndex.value === index;
        const activeItem = activeFormIndex.value >= 0 && activeFormIndex.value < formList.value.length
          ? formList.value[activeFormIndex.value]
          : null;
        const activeItemId = activeItem?.Id ?? activeItem?.id;

        // 如果删除的是当前选中的表单，清空选中状态
        if (isDeletingActive) {
          activeFormIndex.value = -1;
          currentForm.value = null;
          currentFormEditable.value = false;
        } else if (activeFormIndex.value > index) {
          // 如果删除的项在当前选中项之前，需要调整索引
          activeFormIndex.value--;
        }

        if (formList.value.length === 1 && formPagination.value.page > 1) {
          formPagination.value.page--;
        }
        await loadFormList();
        if (!isDeletingActive && activeItemId) {
          const foundItem = findFormItem(activeItemId);
          if (foundItem) {
            activeFormIndex.value = findFormIndex(foundItem);
          } else {
            activeFormIndex.value = -1;
            currentForm.value = null;
            currentFormEditable.value = false;
          }
        }
        ElMessage.success('删除成功');
      } else {
        ElMessage.error('删除失败');
      }
    } catch (error) {
      console.error('删除表单失败:', error);
      ElMessage.error('删除失败');
    }
  }).catch(() => { /* cancelled */ });
};

// 生成楼栋按钮
const generateBuildings = () => {
  if (!currentForm.value) return;

  const count = currentForm.value.buildingCount;
  if (count <= 0) {
    ElMessage.warning('建筑个数必须大于0');
    return;
  }

  if (count > 20) {
    ElMessage.warning('建筑个数不能超过20');
    return;
  }

  const currentBuildings = currentForm.value.buildings || [];
  const currentCount = currentBuildings.length;

  // 如果新数量小于当前数量，需要删除多余的建筑
  if (count < currentCount) {
    currentForm.value.buildings = currentBuildings.slice(0, count);
    // 如果删除的是当前选中的建筑，重置选择
    if (selectedBuildingIndex.value !== null && selectedBuildingIndex.value >= count) {
      selectedBuildingIndex.value = 0;
      if (currentForm.value.buildings.length > 0) {
        currentForm.value.buildings.forEach((b, idx) => {
          b.selected = idx === 0;
        });
      }
    }
  }
  // 如果新数量大于当前数量，添加新的建筑
  else if (count > currentCount) {
    for (let i = currentCount + 1; i <= count; i++) {
      currentForm.value.buildings.push({
        id: Date.now().toString() + i,
        code: '',
        name: `${i}号楼`,
        floors: 1,
        basementFloors: 0,
        selected: false,
        floorDocuments: ensureFloorDocumentsStructure(1),
        editing: false
      });
    }
  }

  initializeBuildingSelection(currentForm.value);

  ElMessage.success(`成功生成${count}栋楼`);
};

// 选择楼栋
const currentFloorDocuments = computed<FloorDocument[]>(() => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return [];
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  building.floorDocuments = ensureFloorDocumentsStructure(building.floors, building.floorDocuments, building.basementFloors);
  return building.floorDocuments;
});

const selectedFloorDocument = computed<FloorDocument | null>(() => {
  const documents = currentFloorDocuments.value;
  if (documents.length === 0) return null;
  if (selectedFloorIndex.value === null || selectedFloorIndex.value >= documents.length) {
    return documents[0];
  }
  return documents[selectedFloorIndex.value];
});

const selectBuilding = (index: number) => {
  if (!currentForm.value) return;

  // 取消之前选中项的选中状态
  currentForm.value.buildings.forEach((building, idx) => {
    building.selected = idx === index;
    building.editing = false;
  });

  selectedBuildingIndex.value = index;
  selectedFloorIndex.value = 0;
};

const startBuildingRename = (index: number) => {
  if (!isEditMode.value || !currentForm.value) return;
  currentForm.value.buildings.forEach((building, idx) => {
    building.editing = idx === index;
  });
  nextTick(() => {
    // 保持按钮选中状态不变
    selectBuilding(index);
  });
};

const finishBuildingRename = (index: number) => {
  if (!currentForm.value) return;
  const building = currentForm.value.buildings[index];
  if (!building) return;
  building.name = (building.name || '').trim() || `${index + 1}号楼`;
  building.editing = false;
};

const selectFloor = (index: number) => {
  const documents = currentFloorDocuments.value;
  if (index >= 0 && index < documents.length) {
    selectedFloorIndex.value = index;
  }
};

const handleBuildingFloorChange = (value: number | null) => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  const floors = value && value > 0 ? value : 0;
  building.floors = floors;
  building.floorDocuments = ensureFloorDocumentsStructure(floors, building.floorDocuments, building.basementFloors);
  const totalFloors = building.floorDocuments.length;
  if (!floors && !(building.basementFloors || 0)) {
    selectedFloorIndex.value = null;
  } else if (selectedFloorIndex.value === null || selectedFloorIndex.value >= totalFloors) {
    selectedFloorIndex.value = totalFloors > 0 ? totalFloors - 1 : null;
  }
};

// 地下层数变化
const handleBasementFloorChange = (value: number | null) => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  const basementFloors = value && value > 0 ? Math.floor(value) : 0;
  building.basementFloors = basementFloors;
  building.floorDocuments = ensureFloorDocumentsStructure(building.floors, building.floorDocuments, basementFloors);
  const totalFloors = building.floorDocuments.length;
  if (!building.floors && !basementFloors) {
    selectedFloorIndex.value = null;
  } else if (selectedFloorIndex.value === null || selectedFloorIndex.value >= totalFloors) {
    selectedFloorIndex.value = totalFloors > 0 ? totalFloors - 1 : null;
  }
};

// 增加/减少地下层数
const incrementBasementFloor = () => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  if (building.basementFloors < 50) {
    building.basementFloors++;
    handleBasementFloorChange(building.basementFloors);
  }
};

const decrementBasementFloor = () => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  if (building.basementFloors > 0) {
    building.basementFloors--;
    handleBasementFloorChange(building.basementFloors);
  }
};

// 增加楼层
const incrementFloor = () => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  if (building.floors < 100) {
    building.floors++;
    handleBuildingFloorChange(building.floors);
  }
};

// 减少楼层
const decrementFloor = () => {
  if (!currentForm.value || selectedBuildingIndex.value === null) return;
  const building = currentForm.value.buildings[selectedBuildingIndex.value];
  if (building.floors > 1) {
    building.floors--;
    handleBuildingFloorChange(building.floors);
  }
};

// 重置表单
const resetForm = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
  if (currentForm.value) {
    currentForm.value.buildings = [];
    selectedBuildingIndex.value = null;
    selectedFloorIndex.value = null;
  }
};

const handleFloorFileChange: UploadProps['onChange'] = async (_file, uploadFiles) => {
  const doc = selectedFloorDocument.value;
  if (!doc) return;
  const first = uploadFiles[0];
  if (!first || !first.raw) return;

  if (!isSupportedDrawingFile(first as any)) {
    ElMessage.warning('仅支持图片和 PDF 格式的图纸');
    return;
  }

  const isPdf = isPdfFile(first);

  floorUploading.value = true; // 开始上传
  floorUploadProgress.value = 0; // 重置进度
  try {
    const form = new FormData();
    // 上传接口统一使用 image 字段，PDF 也必须先取得服务器文件编码后才能随项目保存。
    form.append('image', first.raw as any, (first as any).name || (isPdf ? 'upload.pdf' : 'upload.jpg'));
    const res: any = await ParameterSettings.operatingProjectUploadWithProgress(form, (progress: number) => {
      floorUploadProgress.value = progress;
    });
    if (res && res.success) {
      const code = res.response || res.data;
      const uploaded: any = {
        name: first.name,
        uid: genFileId(),
        status: 'success',
        serverCode: code,
        url: '',
        loading: true,
        isPdf
      };

      if (isPdf) {
        uploaded.raw = first.raw;
        uploaded.pdfUrl = URL.createObjectURL(first.raw);
        uploaded.thumbnailUrl = '';
      }

      // 每层只保留一张
      doc.files.splice(0, doc.files.length, uploaded);

      if (isPdf) {
        generatePdfThumbnail(first.raw).then(thumbnailUrl => {
          uploaded.thumbnailUrl = thumbnailUrl;
        }).catch((error) => {
          console.warn('生成 PDF 缩略图失败:', error);
        }).finally(() => {
          uploaded.loading = false;
          if (doc.files.length > 0) doc.files.splice(0, 1, { ...uploaded });
        });
      } else {
        fetchImageContent(code).then(url => {
          if (url) uploaded.url = url;
          uploaded.loading = false;
          if (doc.files.length > 0) doc.files.splice(0, 1, { ...uploaded });
        }).catch((err) => {
          console.error('获取缩略图失败:', err);
          uploaded.loading = false;
          if (doc.files.length > 0) doc.files.splice(0, 1, { ...uploaded });
        });
      }

      ElMessage.success(isPdf ? 'PDF 上传成功' : '上传成功');
    } else {
      ElMessage.error('上传失败');
    }
  } catch (e) {
    console.error('上传失败', e);
    ElMessage.error('上传失败');
  } finally {
    floorUploading.value = false; // 上传结束
    floorUploadProgress.value = 0; // 重置进度
  }
};

// 处理超出文件数量限制
const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
  ElMessage.warning('每层只能上传一张图纸，如需更换请先删除当前图纸');
};

const handleFloorFileRemove: UploadProps['onRemove'] = () => {
  // 使用自定义删除按钮处理，onRemove不做同步
};

// 自定义删除文件函数（同时请求后端删除）
const removeFloorFile = async (fileIndex: number) => {
  const doc = selectedFloorDocument.value;
  if (!doc || fileIndex < 0 || fileIndex >= doc.files.length) return;
  const target: any = doc.files[fileIndex];
  try {
    await ElMessageBox.confirm('确定要删除这个图纸吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    });
    if (target?.serverCode) {
      try {
        await ParameterSettings.operatingProjectDeleteImage({ fileName: target.serverCode });
      } catch (e) {
        console.warn('后端删除失败或已不存在，继续本地移除', e);
      }
    }
    doc.files.splice(fileIndex, 1);
    ElMessage.success('删除成功');
  } catch {
    // 用户取消
  }
};

// 批量上传文件夹功能
const batchUpload = () => {
  if (!currentForm.value || selectedBuildingIndex.value === null) {
    ElMessage.warning('请先选择楼栋');
    return;
  }

  const input = document.createElement('input');
  input.type = 'file';
  input.webkitdirectory = true;
  input.multiple = true;
  input.accept = 'image/*,.pdf,application/pdf';

  input.onchange = async (event: any) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // 将文件按名称排序
    const selectedFiles = Array.from(files) as File[];
    const ignoredCount = selectedFiles.filter(file => !isSupportedDrawingFile(file)).length;
    const fileArray = selectedFiles.filter(file => isSupportedDrawingFile(file)).sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return nameA.localeCompare(nameB);
    });

    if (fileArray.length === 0) {
      ElMessage.warning('文件夹中没有可上传的图片或 PDF 图纸');
      return;
    }
    if (ignoredCount > 0) {
      ElMessage.warning(`已忽略 ${ignoredCount} 个非图片或 PDF 文件`);
    }

    const building = currentForm.value!.buildings[selectedBuildingIndex.value!];
    // 确保楼层文档覆盖“地下层+地上层”（升序：地下在前，地上在后）
    building.floorDocuments = ensureFloorDocumentsStructure(building.floors, building.floorDocuments, building.basementFloors);
    const floorDocs = building.floorDocuments;
    const allFloorNumbers = floorDocs.map(doc => doc.floorNumber);
    const assignedFloorNumbers = new Set<number>();
    let uploadedCount = 0;

    // 从文件名解析所属楼层（如 -2.jpg、-1.jpg、1.jpg），无法识别时按顺序补位
    const resolveTargetDoc = (file: File): FloorDocument | null => {
      const parsedFloor = parseDrawingFloorFromName(file.name);
      if (parsedFloor !== null && allFloorNumbers.includes(parsedFloor) && !assignedFloorNumbers.has(parsedFloor)) {
        const matched = floorDocs.find(doc => doc.floorNumber === parsedFloor);
        if (matched) return matched;
      }
      // 未识别或楼层已占用：优先补位到尚未分配图纸的地上层，其次地下层
      const freeDocs = floorDocs.filter(doc => !assignedFloorNumbers.has(doc.floorNumber));
      const aboveGround = freeDocs.find(doc => doc.floorNumber > 0);
      return aboveGround || freeDocs[0] || null;
    };

    // 分配文件到各楼层并上传，每层只保留一张图纸
    for (const file of fileArray) {
      const targetDoc = resolveTargetDoc(file);
      if (!targetDoc) break;
      const targetFloorNumber = targetDoc.floorNumber;
      const isPdf = isPdfFile(file as any);

      try {
        const form = new FormData();
        // 按参考实现，使用 image 字段并携带文件名
        form.append('image', file, file.name || (isPdf ? 'upload.pdf' : 'upload.jpg'));
        const res: any = await ParameterSettings.operatingProjectUpload(form);
        if (res && res.success) {
          const code = res.response || res.data;
          const uploaded: any = {
            name: file.name,
            uid: genFileId(),
            status: 'success',
            serverCode: code,
            url: '',
            loading: true,
            isPdf
          };

          if (isPdf) {
            uploaded.raw = file;
            uploaded.pdfUrl = URL.createObjectURL(file);
            uploaded.thumbnailUrl = '';
          }

          // 每层只保留一张图纸
          targetDoc.files = [uploaded];
          assignedFloorNumbers.add(targetFloorNumber);
          uploadedCount += 1;

          const finishPreview = () => {
            uploaded.loading = false;
            if (targetDoc.files.length) {
              targetDoc.files.splice(0, 1, { ...uploaded });
            }
          };

          if (isPdf) {
            generatePdfThumbnail(file).then(thumbnailUrl => {
              uploaded.thumbnailUrl = thumbnailUrl;
            }).catch((error) => {
              console.warn('生成 PDF 缩略图失败:', error);
            }).finally(finishPreview);
          } else {
            fetchImageContent(code).then(url => {
              if (url) uploaded.url = url;
            }).finally(finishPreview);
          }
        } else {
          ElMessage.error(`第${targetFloorNumber}层上传失败`);
        }
      } catch (e) {
        console.error('批量上传失败:', e);
        ElMessage.error(`第${targetFloorNumber}层上传失败`);
      }
    }

    // 更新当前选中楼层的文件显示
    if (selectedFloorIndex.value !== null && floorDocs[selectedFloorIndex.value]) {
      selectedFloorDocument.value?.files.splice(0, selectedFloorDocument.value?.files.length, ...floorDocs[selectedFloorIndex.value].files);
    }

    ElMessage.success(`成功批量上传 ${uploadedCount} 个楼层的图纸`);
  };

  input.click();
};

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(((reader.result as string) || '').split(',')[1] || '');
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

// 保存表单数据
const saveFormData = async () => {
  if (!currentForm.value) {
    ElMessage.warning('请先选择或创建表单');
    return;
  }

  // 表单验证
  if (formRef.value) {
    await formRef.value.validate(async (valid: boolean) => {
      if (valid) {
        const currentItem = activeFormIndex.value >= 0 && activeFormIndex.value < formList.value.length
          ? formList.value[activeFormIndex.value]
          : null;

        const itemId = currentItem?.Id || currentItem?.id;
        const isNew = currentItem?._isNew || !itemId;

        // 校验：楼栋报告编号必填
        if (!currentForm.value) {
          ElMessage.warning('表单数据为空');
          return;
        }
        const buildingsArr = currentForm.value.buildings || [];
        const missingIndex = buildingsArr.findIndex(b => !b.code || !String(b.code).trim());
        if (missingIndex !== -1) {
          selectBuilding(missingIndex);
          ElMessage.warning('请为所有楼栋填写报告编号');
          return;
        }

        let submitStatus = currentForm.value?.status || currentItem?.状态 || currentItem?.status || '';
        if (submitStatus === '等待配置完成') {
          try {
            await ElMessageBox.confirm(
              '当前项目为“等待配置完成”，是否配置完成”？',
              '提示',
              {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                distinguishCancelAndClose: true
              }
            );
            submitStatus = '配置完成，执行中';
          } catch {
            // 选择“否”或关闭弹框时，保持原状态继续保存
          }
        }

        // 处理建筑图纸文件，提交服务器返回的文件编码
        const buildingList = await Promise.all((currentForm.value?.buildings || []).map(async (building) => {
          // 处理每个楼层的图纸文件，确保所有楼层都有占位数据（楼层升序：地下在前、地上在后）
          const floorDocs = ensureFloorDocumentsStructure(building.floors, building.floorDocuments, building.basementFloors);
          const drawings = [];

          // 为每一层创建图纸数据（即使没有上传图片也需要占位），并标注该图纸所属层数
          for (const floorDoc of floorDocs) {
            // 查找该楼层是否已有上传的文件
            const uploadedFile = floorDoc && floorDoc.files && floorDoc.files.length > 0 ? floorDoc.files[0] : undefined;
            // 每层只处理第一个文件（确保只有一张图片）
            const f: any = uploadedFile;
            const code = f?.serverCode;
            drawings.push({
              导航ID: '',
              内容: code || '',
              层数: floorDoc.floorNumber,
              ISDELETED: false,
              Id: ''
            });
          }

          return {
            报告编号: building.code,
            名称: building.name,
            层数: building.floors.toString(),
            地下层数: (building.basementFloors || 0) > 0 ? building.basementFloors : null,
            经营项目ID: itemId || '',
            图纸包: drawings,
            ISDELETED: false,
            Id: ''
          };
        })) || [];

        // 准备提交数据 - 构造符合接口要求的数据格式
        const startISO = currentForm.value?.startTime ? new Date(currentForm.value.startTime as any).toISOString() : undefined;
        const projectAssistantObj = currentForm.value?.projectAssistant || {};
        const executionTeamObj = currentForm.value?.executionTeam || {};
        const submitData = {
          编码: currentForm.value?.code,
          状态: submitStatus,
          名称: currentForm.value?.name,
          项目负责人: currentForm.value?.projectManager,
          项目负责人code: currentForm.value?.projectManagerCode,
          主责部门: currentForm.value?.responsibleDepartment,
          项目助理: projectAssistantObj,
          项目助理codejson: JSON.stringify(projectAssistantObj),
          说明: currentForm.value?.remark,
          项目开始时间: startISO,
          ISDELETED: false,
          建筑列表: buildingList,
          检测项目列表: selectedProjectIds.value.map(id => ({ Id: id })),
          执行团队: executionTeamObj,
          执行团队codejson: JSON.stringify(executionTeamObj),
          Id: itemId || ''
        };

        try {
          // 开始保存，显示loading
          saveLoading.value = true;

          // 调用保存接口
          const res = await ParameterSettings.operatingProjectSave(
            submitData

          );

          if (res && res.status === 200 && res.success) {
            if (isNew) {
              ElMessage.success('新增成功');
              // 获取返回的ID（后端返回格式：response.ID）
              const newId = res.response?.ID || res.response?.Id || res.response?.id;
              const targetName = currentForm.value?.name;

              // 新增成功后刷新列表
              formPagination.value.page = 1;
              await loadFormList();

              // 刷新列表后，重新选中当前项（优先通过ID匹配，其次通过名称匹配）
              const foundItem = newId ? findFormItem(newId) : findFormItem(undefined, targetName);
              if (foundItem) {
                await handleFormSelect(foundItem);
              } else if (newId) {
                const detailRes = await ParameterSettings.operatingProjectById({ id: newId });
                if (detailRes && detailRes.status === 200 && detailRes.success && detailRes.response) {
                  currentFormEditable.value = toEditableFlag((detailRes as any).editable,
                    toEditableFlag((detailRes as any).response?.editable, false));
                  const formData = await loadFormDetail(detailRes.response);
                  currentForm.value = formData;
                  selectedProjectIds.value = Array.isArray(formData.projectIds) ? [...formData.projectIds] : [];
                  selectedProjectsFullData.value = Array.isArray(formData.projectsData) ? [...formData.projectsData] : [];
                  initializeBuildingSelection(currentForm.value);
                  activeFormIndex.value = -1;
                }
              }
              // 保存成功后退出编辑模式
              isEditMode.value = false;
            } else {
              ElMessage.success('更新成功');
              if (currentItem) {
                currentItem.状态 = submitStatus;
                currentItem.status = submitStatus;
                currentItem.名称 = currentForm.value?.name;
                currentItem.name = currentForm.value?.name;
                currentItem.编码 = currentForm.value?.code;
              }
              currentForm.value.status = submitStatus;

              // 保存成功后刷新左侧列表，确保列表中的主责部门等字段同步更新
              await loadFormList();

              // 保存成功后重新加载当前表单数据以确保显示最新数据
              if (itemId) {
                await handleFormSelect({ Id: itemId, id: itemId });
              }
              // 保存成功后退出编辑模式
              isEditMode.value = false;
            }
          } else {
            ElMessage.error(isNew ? '新增失败' : '更新失败');
          }
        } catch (error) {
          console.error('保存表单数据失败:', error);
          ElMessage.error(isNew ? '新增失败' : '更新失败');
        } finally {
          // 保存完成，关闭loading
          saveLoading.value = false;
        }
      } else {
        ElMessage.warning('请填写必填项');
      }
    });
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "main-content",
          ref_key: "mainContentRef",
          ref: mainContentRef
        }, [
          _createElementVNode("div", {
            class: "left-panel",
            ref_key: "leftPanelRef",
            ref: leftPanelRef,
            style: _normalizeStyle({ width: leftPanelWidth.value + 'px' })
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(can)('新增'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: addNewForm,
                    icon: _unref(Plus)
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" 新增 ")
                    ])),
                    _: 1
                  }, 8, ["icon"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_input, {
                modelValue: quickKeyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quickKeyword).value = $event)),
                placeholder: "关键词",
                clearable: "",
                class: "quick-keyword-input"
              }, null, 8, ["modelValue"]),
              (_unref(can)('列表'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: handleQuickQuery,
                    loading: listLoading.value
                  }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createTextVNode("快速查询")
                    ])),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              (_unref(can)('快速同步'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    onClick: handleQuickSync,
                    loading: quickSyncLoading.value
                  }, {
                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                      _createTextVNode("快速同步")
                    ])),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                class: "app-refresh-btn",
                onClick: loadFormList,
                loading: listLoading.value,
                icon: _unref(Refresh),
                style: {"margin-left":"auto"},
                title: "刷新",
                circle: ""
              }, null, 8, ["loading", "icon"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DynamicTable, {
                ref_key: "dynamicTableRef",
                ref: dynamicTableRef,
                data: formListData.value,
                model: tableModel.value,
                loading: listLoading.value,
                "show-column-selector": false,
                "show-export": false,
                "show-edit-button": false,
                "show-delete-button": false,
                pagination: formPagination.value,
                "column-order": ['编码', '名称', '主责部门', '项目负责人'],
                "column-widths": { '名称': 260 },
                "active-row-key": activeFormRowKey.value,
                onDelete: handleFormDelete,
                onFilter: handleFilter,
                onPageChange: handleFormPageChange,
                onPageSizeChange: handleFormPageSizeChange
              }, {
                action: _withCtx(({ row }) => [
                  (_unref(can)('项目详情'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        icon: _unref(View),
                        plain: "",
                        onClick: ($event: any) => (handleFormEdit(row))
                      }, null, 8, ["icon", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "model", "loading", "pagination", "active-row-key"])
            ])
          ], 4),
          _createElementVNode("div", {
            class: "resize-handle",
            onMousedown: startResize
          }, null, 32),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            (currentForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!isEditMode.value && _unref(can)('编辑'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: enterEditMode,
                          icon: _unref(Edit),
                          disabled: !canEnterEditMode.value
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode(" 编辑 ")
                          ])),
                          _: 1
                        }, 8, ["icon", "disabled"]))
                      : _createCommentVNode("", true),
                    (isEditMode.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "info",
                          onClick: exitEditMode,
                          icon: _unref(Close)
                        }, {
                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createTextVNode(" 取消编辑 ")
                          ])),
                          _: 1
                        }, 8, ["icon"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_badge, {
                      value: projectFileCount.value,
                      type: "success",
                      class: "current-file-badge"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          icon: _unref(Document),
                          onClick: openProjectFileDialog,
                          loading: projectFilesLoading.value
                        }, {
                          default: _withCtx(() => _cache[40] || (_cache[40] = [
                            _createTextVNode(" 当前文件 ")
                          ])),
                          _: 1
                        }, 8, ["icon", "loading"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Upload),
                      onClick: openProjectFileUploadDialog
                    }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode(" 文件上传 ")
                      ])),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _createVNode(_component_el_form, {
                    model: currentForm.value,
                    rules: formRules,
                    ref_key: "formRef",
                    ref: formRef,
                    "label-width": "120px",
                    class: "form-content"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "项目名称：" }, {
                        default: _withCtx(() => [
                          (isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_el_input, {
                                  modelValue: currentForm.value.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentForm.value.name) = $event)),
                                  placeholder: "请输入项目名称"
                                }, null, 8, ["modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(currentForm.value.name || '-'), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "项目开始时间：" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_el_date_picker, {
                              modelValue: currentForm.value.startTime,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentForm.value.startTime) = $event)),
                              type: "date",
                              readonly: !isEditMode.value,
                              disabled: !isEditMode.value,
                              placeholder: "请选择项目开始时间",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue", "readonly", "disabled"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "编码：" }, {
                        default: _withCtx(() => [
                          (isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_el_input, {
                                  modelValue: currentForm.value.code,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentForm.value.code) = $event)),
                                  placeholder: "请输入编码"
                                }, null, 8, ["modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(currentForm.value.code || '-'), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "项目负责人：" }, {
                        default: _withCtx(() => [
                          (isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(currentForm.value.projectManager || '-'), 1),
                                (_unref(canAny)('配置团队获取部门', '获取部门下成员'))
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      type: "primary",
                                      plain: "",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (openMemberDialog('manager')))
                                    }, {
                                      default: _withCtx(() => _cache[42] || (_cache[42] = [
                                        _createTextVNode("选择")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(currentForm.value.projectManager || '-'), 1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "主责部门：" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            (currentForm.value.responsibleDepartment)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "warning",
                                  effect: "light",
                                  size: "default",
                                  class: "dept-tag",
                                  closable: isEditMode.value,
                                  onClose: _cache[5] || (_cache[5] = ($event: any) => (currentForm.value.responsibleDepartment = ''))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, { class: "dept-tag-icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(OfficeBuilding))
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(currentForm.value.responsibleDepartment), 1)
                                  ]),
                                  _: 1
                                }, 8, ["closable"]))
                              : _createCommentVNode("", true),
                            (isEditMode.value && !currentForm.value.responsibleDepartment)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "primary",
                                  plain: "",
                                  onClick: openDeptDialog
                                }, {
                                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                                    _createTextVNode("选择")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (isEditMode.value || assistantList.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_el_form_item, { label: "项目助理：" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assistantList.value, (member) => {
                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                      key: member.code,
                                      type: "",
                                      size: "default",
                                      class: "team-tag",
                                      closable: isEditMode.value,
                                      onClose: ($event: any) => (removeAssistantMember(member.code))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(member.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["closable", "onClose"]))
                                  }), 128)),
                                  (isEditMode.value && _unref(canAny)('配置团队获取部门', '获取部门下成员'))
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "primary",
                                        plain: "",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (openMemberDialog('assistant')))
                                      }, {
                                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                                          _createTextVNode(" 选择 ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (isEditMode.value || executionTeamList.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_el_form_item, { label: "执行团队：" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(executionTeamList.value, (member) => {
                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                      key: member.code,
                                      closable: isEditMode.value,
                                      onClose: ($event: any) => (removeTeamMember(member.code)),
                                      type: "success",
                                      size: "default",
                                      class: "team-tag"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(member.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["closable", "onClose"]))
                                  }), 128)),
                                  (isEditMode.value && _unref(canAny)('配置团队获取部门', '获取部门下成员'))
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "primary",
                                        plain: "",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (openMemberDialog('execution')))
                                      }, {
                                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                                          _createTextVNode(" 选择 ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "说明",
                        prop: "remark"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: currentForm.value.remark,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentForm.value.remark) = $event)),
                            readonly: !isEditMode.value,
                            type: "textarea",
                            placeholder: "请输入说明信息"
                          }, null, 8, ["modelValue", "readonly"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "建筑个数",
                        prop: "buildingCount",
                        class: "building-count-item"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_el_input_number, {
                              modelValue: currentForm.value.buildingCount,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentForm.value.buildingCount) = $event)),
                              readonly: !isEditMode.value,
                              min: 0,
                              max: 20,
                              precision: 0,
                              "controls-position": "right",
                              placeholder: "请输入建筑个数，最大20",
                              style: {"width":"200px"}
                            }, null, 8, ["modelValue", "readonly"]),
                            (isEditMode.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: generateBuildings
                                }, {
                                  default: _withCtx(() => _cache[46] || (_cache[46] = [
                                    _createTextVNode(" 确定 ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      (currentForm.value.buildings.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "buildings-header" }, [
                              _createElementVNode("h3", null, "楼栋信息")
                            ], -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_el_row, { gutter: 10 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentForm.value.buildings, (building, index) => {
                                    return (_openBlock(), _createBlock(_component_el_col, {
                                      key: building.id,
                                      xs: 12,
                                      sm: 8,
                                      md: 6,
                                      lg: 4
                                    }, {
                                      default: _withCtx(() => [
                                        (building.editing && isEditMode.value)
                                          ? (_openBlock(), _createBlock(_component_el_input, {
                                              key: 0,
                                              modelValue: building.name,
                                              "onUpdate:modelValue": ($event: any) => ((building.name) = $event),
                                              placeholder: "请输入楼栋名称",
                                              size: "small",
                                              onBlur: ($event: any) => (finishBuildingRename(index)),
                                              onKeyup: _withKeys(($event: any) => (finishBuildingRename(index)), ["enter"]),
                                              style: {"margin-bottom":"10px"}
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onKeyup"]))
                                          : (_openBlock(), _createBlock(_component_el_button, {
                                              key: 1,
                                              type: building.selected ? 'primary' : 'default',
                                              onClick: ($event: any) => (selectBuilding(index)),
                                              style: {"width":"100%","margin-bottom":"10px"},
                                              onDblclick: ($event: any) => (startBuildingRename(index))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(building.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["type", "onClick", "onDblclick"]))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            (selectedBuildingIndex.value !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_component_el_divider),
                                  _createElementVNode("h4", null, _toDisplayString(currentForm.value.buildings[selectedBuildingIndex.value].name) + " 层数设置", 1),
                                  _createVNode(_component_el_row, { gutter: 20 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 12 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            label: "楼栋名称",
                                            required: true
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_input, {
                                                modelValue: currentForm.value.buildings[selectedBuildingIndex.value].name,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((currentForm.value.buildings[selectedBuildingIndex.value].name) = $event)),
                                                readonly: !isEditMode.value,
                                                placeholder: "请输入楼栋名称"
                                              }, null, 8, ["modelValue", "readonly"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 12 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            label: "报告编号",
                                            required: true
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_input, {
                                                modelValue: currentForm.value.buildings[selectedBuildingIndex.value].code,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((currentForm.value.buildings[selectedBuildingIndex.value].code) = $event)),
                                                readonly: !isEditMode.value,
                                                placeholder: "请输入报告编号"
                                              }, null, 8, ["modelValue", "readonly"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_row, { gutter: 20 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 12 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, { label: "地上层数" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_24, [
                                                _createVNode(_component_el_input_number, {
                                                  modelValue: currentForm.value.buildings[selectedBuildingIndex.value].floors,
                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((currentForm.value.buildings[selectedBuildingIndex.value].floors) = $event)),
                                                  readonly: !isEditMode.value,
                                                  min: 1,
                                                  max: 100,
                                                  precision: 0,
                                                  controls: false,
                                                  style: {"flex":"1"},
                                                  onChange: handleBuildingFloorChange
                                                }, null, 8, ["modelValue", "readonly"]),
                                                _createVNode(_component_el_button, {
                                                  disabled: !isEditMode.value || currentForm.value.buildings[selectedBuildingIndex.value].floors >= 100,
                                                  onClick: incrementFloor,
                                                  type: "primary",
                                                  icon: _unref(Plus),
                                                  size: "small",
                                                  circle: ""
                                                }, null, 8, ["disabled", "icon"]),
                                                _createVNode(_component_el_button, {
                                                  disabled: !isEditMode.value || currentForm.value.buildings[selectedBuildingIndex.value].floors <= 1,
                                                  onClick: decrementFloor,
                                                  type: "primary",
                                                  icon: _unref(Minus),
                                                  size: "small",
                                                  circle: ""
                                                }, null, 8, ["disabled", "icon"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 12 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, { label: "地下层数" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_25, [
                                                _createVNode(_component_el_input_number, {
                                                  modelValue: currentForm.value.buildings[selectedBuildingIndex.value].basementFloors,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((currentForm.value.buildings[selectedBuildingIndex.value].basementFloors) = $event)),
                                                  readonly: !isEditMode.value,
                                                  min: 0,
                                                  max: 50,
                                                  precision: 0,
                                                  controls: false,
                                                  style: {"flex":"1"},
                                                  onChange: handleBasementFloorChange
                                                }, null, 8, ["modelValue", "readonly"]),
                                                _createVNode(_component_el_button, {
                                                  disabled: !isEditMode.value || currentForm.value.buildings[selectedBuildingIndex.value].basementFloors >= 50,
                                                  onClick: incrementBasementFloor,
                                                  type: "primary",
                                                  icon: _unref(Plus),
                                                  size: "small",
                                                  circle: ""
                                                }, null, 8, ["disabled", "icon"]),
                                                _createVNode(_component_el_button, {
                                                  disabled: !isEditMode.value || currentForm.value.buildings[selectedBuildingIndex.value].basementFloors <= 0,
                                                  onClick: decrementBasementFloor,
                                                  type: "primary",
                                                  icon: _unref(Minus),
                                                  size: "small",
                                                  circle: ""
                                                }, null, 8, ["disabled", "icon"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_26, [
                                    (currentFloorDocuments.value.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createElementVNode("div", _hoisted_28, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFloorDocuments.value, (doc, floorIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: doc.floorNumber,
                                                class: _normalizeClass(['floor-list-item', { active: selectedFloorIndex.value === floorIndex }]),
                                                onClick: ($event: any) => (selectFloor(floorIndex))
                                              }, _toDisplayString(doc.floorNumber) + " 层 ", 11, _hoisted_29))
                                            }), 128))
                                          ]),
                                          (selectedFloorDocument.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                  _createElementVNode("h5", null, _toDisplayString(selectedFloorDocument.value.floorNumber) + " 层图纸", 1)
                                                ]),
                                                (floorUploading.value)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                      _createVNode(_component_el_progress, {
                                                        type: "circle",
                                                        percentage: floorUploadProgress.value,
                                                        width: 80,
                                                        "stroke-width": 6
                                                      }, {
                                                        default: _withCtx(({ percentage }) => [
                                                          _createElementVNode("span", _hoisted_33, _toDisplayString(percentage) + "%", 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["percentage"]),
                                                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "progress-label" }, "上传中...", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (!floorUploading.value && _unref(can)('图片上传'))
                                                  ? (_openBlock(), _createBlock(_component_el_upload, {
                                                      key: 1,
                                                      class: "floor-upload",
                                                      drag: "",
                                                      action: "#",
                                                      "file-list": selectedFloorDocument.value.files,
                                                      "auto-upload": false,
                                                      "on-change": handleFloorFileChange,
                                                      "on-remove": handleFloorFileRemove,
                                                      disabled: !isEditMode.value || floorUploading.value,
                                                      limit: 1,
                                                      "on-exceed": handleExceed,
                                                      accept: "image/*,.pdf,application/pdf",
                                                      "show-file-list": false
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_icon, { class: "upload-icon" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(UploadFilled))
                                                          ]),
                                                          _: 1
                                                        }),
                                                        (selectedFloorDocument.value.files.length === 0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(isEditMode.value ? '拖拽或点击上传图纸' : '查看模式，无法上传图纸'), 1))
                                                          : _createCommentVNode("", true),
                                                        (selectedFloorDocument.value.files.length === 0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(isEditMode.value ? '每层只能上传一张图纸，文件暂存于当前页面，保存后统一提交' : '请切换到编辑模式进行图纸上传'), 1))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["file-list", "disabled"]))
                                                  : _createCommentVNode("", true),
                                                (selectedFloorDocument.value.files.length > 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                      _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("span", null, "已上传图纸 (" + _toDisplayString(selectedFloorDocument.value.files.length) + "个)", 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_38, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFloorDocument.value.files, (file, fileIndex) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: file.uid,
                                                            class: "file-item"
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: "file-content",
                                                              onClick: ($event: any) => (previewImage(file))
                                                            }, [
                                                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                ((file as any).isPdf)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                      ((file as any).thumbnailUrl)
                                                                        ? (_openBlock(), _createElementBlock("img", {
                                                                            key: 0,
                                                                            src: (file as any).thumbnailUrl,
                                                                            class: "file-thumbnail",
                                                                            alt: "PDF缩略图"
                                                                          }, null, 8, _hoisted_41))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                            _createVNode(_component_el_icon, {
                                                                              size: 32,
                                                                              color: "#f56c6c"
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_unref(Document))
                                                                              ]),
                                                                              _: 1
                                                                            }),
                                                                            _cache[48] || (_cache[48] = _createElementVNode("span", { class: "pdf-label" }, "PDF", -1))
                                                                          ]))
                                                                    ], 64))
                                                                  : ((file as any).url)
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 1,
                                                                        src: (file as any).url,
                                                                        class: "file-thumbnail",
                                                                        alt: "缩略图"
                                                                      }, null, 8, _hoisted_43))
                                                                    : (_openBlock(), _createBlock(_component_el_icon, { key: 2 }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(Document))
                                                                        ]),
                                                                        _: 1
                                                                      }))
                                                              ])), [
                                                                [_directive_loading, (file as any).loading]
                                                              ]),
                                                              _createElementVNode("span", _hoisted_44, _toDisplayString(file.name), 1),
                                                              _createVNode(_component_el_tag, {
                                                                size: "small",
                                                                type: "success"
                                                              }, {
                                                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                                  _createTextVNode("已上传")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ], 8, _hoisted_39),
                                                            (_unref(can)('图片上传'))
                                                              ? (_openBlock(), _createBlock(_component_el_button, {
                                                                  key: 0,
                                                                  type: "danger",
                                                                  size: "small",
                                                                  icon: _unref(Close),
                                                                  circle: "",
                                                                  onClick: ($event: any) => (removeFloorFile(fileIndex)),
                                                                  disabled: !isEditMode.value,
                                                                  class: "file-remove-btn"
                                                                }, null, 8, ["icon", "onClick", "disabled"]))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_45, [
                                                  (_unref(can)('图片上传'))
                                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                                        key: 0,
                                                        type: "primary",
                                                        onClick: batchUpload,
                                                        disabled: !isEditMode.value
                                                      }, {
                                                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                                                          _createTextVNode(" 批量上传文件夹 ")
                                                        ])),
                                                        _: 1
                                                      }, 8, ["disabled"]))
                                                    : _createCommentVNode("", true),
                                                  _cache[51] || (_cache[51] = _createElementVNode("div", {
                                                    class: "el-upload__tip",
                                                    style: {"margin-top":"5px"}
                                                  }, " 请按楼层号命名文件，如-2.jpg、-1.jpg、1.jpg、2.pdf，每层只能上传一张图纸 ", -1))
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_46, " 暂无楼层信息，请先设置层数 "))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (isEditMode.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      onClick: openProjectDialog
                                    }, {
                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                        _createTextVNode("选择原始记录")
                                      ])),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (selectedProjectsData.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _cache[53] || (_cache[53] = _createElementVNode("div", { class: "tags-title" }, "已选择的原始记录：", -1)),
                                  _createElementVNode("div", _hoisted_50, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedProjectsData.value, (project, projectIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: 'proj_' + (project.Id || project.id),
                                        class: _normalizeClass(["project-tag-wrapper", { 'is-dragging': draggedProjectIndex.value === projectIndex }]),
                                        draggable: isEditMode.value,
                                        onDragstart: ($event: any) => (handleProjectTagDragStart(projectIndex, $event)),
                                        onDragover: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
                                        onDrop: _withModifiers(($event: any) => (handleProjectTagDrop(projectIndex)), ["prevent"]),
                                        onDragend: _cache[15] || (_cache[15] = ($event: any) => (draggedProjectIndex.value = null))
                                      }, [
                                        _createVNode(_component_el_tag, {
                                          closable: isEditMode.value,
                                          onClose: ($event: any) => (removeSelectedProject(project.Id || project.id)),
                                          type: "primary",
                                          class: "project-tag"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(project.名称 || project.name || project.项目名称 || `项目${project.Id || project.id}`), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["closable", "onClose"])
                                      ], 42, _hoisted_51))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (isEditMode.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  (_unref(can)('保存'))
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "primary",
                                        onClick: saveFormData,
                                        loading: saveLoading.value
                                      }, {
                                        default: _withCtx(() => _cache[54] || (_cache[54] = [
                                          _createTextVNode("保存数据")
                                        ])),
                                        _: 1
                                      }, 8, ["loading"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_button, {
                                    onClick: resetForm,
                                    disabled: saveLoading.value
                                  }, {
                                    default: _withCtx(() => _cache[55] || (_cache[55] = [
                                      _createTextVNode("重置")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createVNode(_component_el_empty, { description: "请先创建或选择一个表单" })
                ]))
          ])), [
            [_directive_loading, loading.value]
          ])
        ], 512)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dialogVisible).value = $event)),
      title: "选择原始记录",
      width: "70%",
      top: "50px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_54, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmProjectSelection
          }, {
            default: _withCtx(() => _cache[57] || (_cache[57] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((activeTab).value = $event)),
          onTabChange: handleTabChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "原始记录包",
              name: "package"
            }, {
              default: _withCtx(() => [
                _createVNode(DynamicTable, {
                  data: packageListData.value,
                  model: packageTableModel.value,
                  loading: packageListLoading.value,
                  "show-column-selector": true,
                  "show-export": false,
                  "show-detail-button": true,
                  "show-edit-button": false,
                  "show-delete-button": false,
                  onDetail: handlePackageDetail,
                  onFilter: handlePackageFilter,
                  showSelection: true,
                  defaultSelection: tempSelectedPackagesData.value,
                  onSelectionChange: handlePackageSelectionChange,
                  height: "400"
                }, null, 8, ["data", "model", "loading", "defaultSelection"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "原始记录",
              name: "project"
            }, {
              default: _withCtx(() => [
                _createVNode(DynamicTable, {
                  data: projectListData.value,
                  model: projectTableModel.value,
                  loading: projectListLoading.value,
                  "show-column-selector": true,
                  "show-export": false,
                  "show-edit-button": false,
                  "show-delete-button": false,
                  onFilter: handleProjectFilter,
                  showSelection: true,
                  defaultSelection: tempSelectedProjectsData.value,
                  onSelectionChange: handleProjectSelectionChange,
                  height: "400"
                }, null, 8, ["data", "model", "loading", "defaultSelection"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: packageDetailVisible.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((packageDetailVisible).value = $event)),
      title: "原始记录包详情",
      width: "60%",
      top: "50px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_59, [
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (packageDetailVisible.value = false))
          }, {
            default: _withCtx(() => _cache[59] || (_cache[59] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (currentPackageDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("h3", null, _toDisplayString(currentPackageDetail.value.名称 || currentPackageDetail.value.name || '项目包'), 1),
                (currentPackageDetail.value.说明 || currentPackageDetail.value.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(currentPackageDetail.value.说明 || currentPackageDetail.value.description), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_58, [
                _cache[58] || (_cache[58] = _createElementVNode("h4", null, "包含的原始记录：", -1)),
                _createVNode(DynamicTable, {
                  data: packageDetailProjects.value,
                  model: packageDetailProjectsModel.value,
                  loading: packageDetailLoading.value,
                  "show-column-selector": true,
                  "show-export": false,
                  "show-detail-button": false,
                  "show-edit-button": false,
                  "show-delete-button": false,
                  showSelection: false,
                  height: "350"
                }, null, 8, ["data", "model", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: projectFileDialogVisible.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((projectFileDialogVisible).value = $event)),
      title: "当前文件",
      width: "85%",
      top: "50px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_61, [
          _createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (projectFileDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[63] || (_cache[63] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_el_button, {
            type: "danger",
            icon: _unref(Delete),
            plain: "",
            loading: clearingProjectFiles.value,
            onClick: clearProjectFiles
          }, {
            default: _withCtx(() => _cache[60] || (_cache[60] = [
              _createTextVNode(" 清空项目文件夹 ")
            ])),
            _: 1
          }, 8, ["icon", "loading"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: projectFiles.value,
          border: "",
          stripe: "",
          "max-height": "600",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "70",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "文件名",
              label: "文件名",
              "min-width": "240",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "文件类型",
              label: "文件类型",
              width: "100",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "大小",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(formatFileSize(row.大小)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "上传时间",
              label: "上传时间",
              width: "170"
            }),
            _createVNode(_component_el_table_column, {
              prop: "上传人",
              label: "上传人",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "210",
              fixed: "right",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  icon: _unref(Download),
                  plain: "",
                  loading: downloadingFileId.value === String(row.Id || ''),
                  onClick: ($event: any) => (downloadProjectFile(row))
                }, {
                  default: _withCtx(() => _cache[61] || (_cache[61] = [
                    _createTextVNode(" 下载 ")
                  ])),
                  _: 2
                }, 1032, ["icon", "loading", "onClick"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  icon: _unref(Delete),
                  plain: "",
                  loading: deletingFileId.value === String(row.Id || ''),
                  onClick: ($event: any) => (deleteProjectFile(row))
                }, {
                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                    _createTextVNode(" 删除 ")
                  ])),
                  _: 2
                }, 1032, ["icon", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, projectFilesLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: projectFileUploadDialogVisible.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((projectFileUploadDialogVisible).value = $event)),
      width: "680px",
      "close-on-click-modal": false,
      class: "project-file-upload-dialog",
      onClosed: resetProjectFileUpload
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("span", _hoisted_63, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Upload))
              ]),
              _: 1
            })
          ]),
          _cache[64] || (_cache[64] = _createElementVNode("span", null, "文件上传", -1))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_71, [
          _createVNode(_component_el_button, {
            disabled: projectFilesUploading.value,
            onClick: _cache[23] || (_cache[23] = ($event: any) => (projectFileUploadDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[68] || (_cache[68] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: projectFilesUploading.value,
            disabled: !projectUploadFileList.value.length,
            onClick: uploadProjectFiles
          }, {
            default: _withCtx(() => _cache[69] || (_cache[69] = [
              _createTextVNode("确定上传")
            ])),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createVNode(_component_el_upload, {
            "file-list": projectUploadFileList.value,
            "onUpdate:fileList": _cache[22] || (_cache[22] = ($event: any) => ((projectUploadFileList).value = $event)),
            action: "#",
            multiple: "",
            "auto-upload": false,
            drag: "",
            "show-file-list": false,
            disabled: projectFilesUploading.value,
            class: "project-file-upload-zone"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_65, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UploadFilled))
                  ]),
                  _: 1
                })
              ]),
              _cache[65] || (_cache[65] = _createElementVNode("div", { class: "project-file-upload-zone-title" }, "选择文件", -1)),
              _cache[66] || (_cache[66] = _createElementVNode("div", { class: "project-file-upload-zone-tip" }, "支持一次选择多个文件", -1))
            ]),
            _: 1
          }, 8, ["file-list", "disabled"]),
          (projectUploadFileList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[67] || (_cache[67] = _createElementVNode("span", null, "待上传文件", -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("span", null, _toDisplayString(projectUploadFileList.value.length) + " 个", 1),
                    _createVNode(_component_el_button, {
                      text: "",
                      type: "danger",
                      icon: _unref(Delete),
                      title: "清空待上传文件",
                      disabled: projectFilesUploading.value,
                      onClick: clearProjectUploadFiles
                    }, null, 8, ["icon", "disabled"])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectUploadFileList.value, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.uid,
                    class: "project-upload-file-item"
                  }, [
                    _createElementVNode("span", _hoisted_69, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", {
                      class: "project-upload-file-name",
                      title: file.name
                    }, _toDisplayString(file.name), 9, _hoisted_70),
                    _createVNode(_component_el_button, {
                      text: "",
                      icon: _unref(Close),
                      title: "移除文件",
                      disabled: projectFilesUploading.value,
                      onClick: ($event: any) => (removeProjectUploadFile(file))
                    }, null, 8, ["icon", "disabled", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: imagePreviewVisible.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((imagePreviewVisible).value = $event)),
      title: previewIsPdf.value ? 'PDF预览' : '图片预览',
      width: "80%",
      top: "50px",
      "destroy-on-close": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_76, [
          _createVNode(_component_el_button, {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (imagePreviewVisible.value = false))
          }, {
            default: _withCtx(() => _cache[70] || (_cache[70] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          (previewIsPdf.value)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: previewImageUrl.value,
                class: "preview-pdf"
              }, null, 8, _hoisted_73))
            : (previewImageUrl.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: previewImageUrl.value,
                  alt: "预览图片",
                  class: "preview-image"
                }, null, 8, _hoisted_74))
              : (_openBlock(), _createElementBlock("div", _hoisted_75, "加载中..."))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: teamDialogVisible.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((teamDialogVisible).value = $event)),
      title: memberDialogTitle.value,
      width: "75%",
      top: "50px",
      "close-on-click-modal": false,
      class: "team-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[30] || (_cache[30] = ($event: any) => (teamDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[74] || (_cache[74] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmTeamSelection
        }, {
          default: _withCtx(() => _cache[75] || (_cache[75] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _cache[71] || (_cache[71] = _createElementVNode("span", { class: "team-panel-title" }, "部门结构", -1)),
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Refresh),
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                onClick: loadTeamDepartmentTree,
                loading: teamTreeLoading.value,
                title: "刷新"
              }, null, 8, ["icon", "loading"])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_el_input, {
                modelValue: teamFilterText.value,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((teamFilterText).value = $event)),
                placeholder: "搜索部门",
                "prefix-icon": _unref(Search),
                clearable: "",
                size: "default",
                onKeyup: _withKeys(handleTeamTreeFilter, ["enter"]),
                onClear: handleTeamTreeFilter
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
              _createVNode(_component_el_tree, {
                ref_key: "teamTreeRef",
                ref: teamTreeRef,
                data: teamDepartmentTree.value,
                props: teamTreeProps,
                "node-key": "value",
                "filter-node-method": filterTeamNode,
                "expand-on-click-node": false,
                "highlight-current": "",
                onNodeClick: handleTeamNodeClick
              }, {
                default: _withCtx(({ node }) => [
                  _createElementVNode("span", _hoisted_82, [
                    _createVNode(_component_el_icon, { class: "node-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OfficeBuilding))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_83, _toDisplayString(node.label), 1)
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])), [
              [_directive_loading, teamTreeLoading.value]
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_el_checkbox, {
                modelValue: teamShowSubUsers.value,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((teamShowSubUsers).value = $event)),
                onChange: handleTeamShowSubChange
              }, {
                default: _withCtx(() => _cache[72] || (_cache[72] = [
                  _createTextVNode("显示下级人员")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("span", _hoisted_87, _toDisplayString(teamCurrentDepartment.value ? teamCurrentDepartment.value.label : '请选择部门'), 1)
            ]),
            (teamCurrentDepartment.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_el_input, {
                      modelValue: teamUserSearchText.value,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((teamUserSearchText).value = $event)),
                      placeholder: "搜索人员姓名",
                      "prefix-icon": _unref(Search),
                      clearable: "",
                      style: {"width":"240px"},
                      onClear: handleTeamUserSearch,
                      onKeyup: _withKeys(handleTeamUserSearch, ["enter"])
                    }, null, 8, ["modelValue", "prefix-icon"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "default",
                      onClick: handleTeamUserSearch
                    }, {
                      default: _withCtx(() => _cache[73] || (_cache[73] = [
                        _createTextVNode("搜索")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createVNode(_component_el_table, {
                      data: teamUserList.value,
                      stripe: "",
                      border: "",
                      style: {"width":"100%"},
                      "max-height": "400"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          width: "55",
                          align: "center"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_checkbox, {
                              "model-value": isTeamMemberSelected(row),
                              onChange: ($event: any) => (toggleTeamMember(row))
                            }, null, 8, ["model-value", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uRealName",
                          label: "姓名",
                          "min-width": "100"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "uLoginName",
                          label: "账号",
                          "min-width": "130"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "DepartmentName",
                          label: "部门",
                          "min-width": "150"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_91, [
                  _createVNode(_component_el_empty, { description: "请在左侧选择一个部门查看人员" })
                ])),
            (Object.keys(tempExecutionTeam.value).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createElementVNode("span", _hoisted_93, "已选 " + _toDisplayString(Object.keys(tempExecutionTeam.value).length) + " 人：", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tempExecutionTeam.value, (name, code) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: code,
                      closable: "",
                      size: "small",
                      type: "success",
                      onClose: ($event: any) => (toggleTeamMember({ code: code as string, uRealName: name } as TeamUserInfo)),
                      style: {"margin":"2px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClose"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, teamUserLoading.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: deptDialogVisible.value,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((deptDialogVisible).value = $event)),
      title: "选择主责部门",
      width: "450px",
      top: "50px",
      "close-on-click-modal": false,
      class: "dept-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[33] || (_cache[33] = ($event: any) => (deptDialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[76] || (_cache[76] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmDeptSelection
        }, {
          default: _withCtx(() => _cache[77] || (_cache[77] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_component_el_input, {
              modelValue: deptFilterText.value,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((deptFilterText).value = $event)),
              placeholder: "搜索部门",
              "prefix-icon": _unref(Search),
              clearable: "",
              size: "default",
              onKeyup: _withKeys(handleDeptTreeFilter, ["enter"]),
              onClear: handleDeptTreeFilter
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_96, [
            _createVNode(_component_el_tree, {
              ref_key: "deptTreeRef",
              ref: deptTreeRef,
              data: deptTreeData.value,
              props: deptTreeProps,
              "node-key": "value",
              "filter-node-method": filterDeptNode,
              "expand-on-click-node": false,
              "highlight-current": "",
              onNodeClick: handleDeptNodeClick
            }, {
              default: _withCtx(({ node }) => [
                _createElementVNode("span", _hoisted_97, [
                  _createVNode(_component_el_icon, { class: "node-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OfficeBuilding))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_98, _toDisplayString(node.label), 1)
                ])
              ]),
              _: 1
            }, 8, ["data"])
          ])), [
            [_directive_loading, deptTreeLoading.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})